/* eslint-disable */
import dayjs from "dayjs";
import _ from "lodash/fp";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import "react-transliterate/dist/index.css";
import advertisementDetailsLabel from "../../application_management/labels/advertisement_details_en.json";
import { getAllLookupOptionsAPI } from "../../common/actions/commonActions";
import ModuleHide from "../../common/components/ModuleHide";
import { SET_AUTHENTICATION_DATA_OBJ, SET_CITIZENSHIP_WARNING_MSG } from "../../common/constants/ActionTypes";
import { aadhaarNumber, alphabets, alphanumeric, certificateNumbeForNclandDomicileRegex, drivingLicenseRegex, fullname, panCardRegex, weightRegex } from "../../common/constants/regex";
import commonENLabels from "../../common/labels/common_en.json";
import commonHILabels from "../../common/labels/common_hi.json";
import { dateDifferece, getFormattedDate, preventDateManualTyping, toUTCDate } from "../../helpers/Datetime";
import { getLookOptionsForADropdown } from "../../helpers/LookupOptionHelper";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/advertisementTable.css";
import "../../styles/profile.css";
import { clearSportForm, disableAllSaveAfterSubmit, getFormattedLastUpdatedDate, getPersonalInfoData, getPersonalInfoDigilockerStatus, savePersonalInfoData, setSportsDetails } from "../actions/profileAction";
import profileotherinformation from "../labels/other_information_en.json";
import profile from "../labels/personal_information_en.json";
import numberformat from "../labels/serial_nos_en.json";
import Devnagari from "./devnagari";



const shortNameMaxLength = 100;
const mandatoryMultipleDisabilitySubCats = [454, 455];
const multiSelectCatId = 439;

function PersonalInformation(props) {

  const { profileCreationAllLookupData, meritoriousSportsmanDtoList, additionResEnvData, allDisabilitiesData, personalInfoDigilockerStatuses, setCitizenWarningMsgData } = useSelector((state) => state.profile, shallowEqual);

  let { allLookUpList } = useSelector((state) => state.common, shallowEqual);

  const isDisableAllTabSave = useSelector(
    (state) => state.profile.isDisableAllTabSave
  );
  const [personal_info_form, setSaveData] = useState([]);
  const profileFormDetailsData = useSelector(
    (state) => state.profile.personalInfo
  );
  const [hideCastCertificate, setHideCastCertificate] = useState(false);

  const [hideNCL, setHideNCL] = useState(false);
  const [hideCastValidity, setHideCastValidity] = useState(false);
  const [showEWS, setShowEWS] = useState(false);
  const [disabilitySubCategoriesOptions, setDisabilitySubCategoriesOptions] =
    useState([]);
  const [
    disabilitySubCategoriesLookupIdsList,
    setDisabilitySubCategoriesLookupIds,
  ] = useState("");
  const [projectAffectedPersonFlag, setProjectAffectedPersonFlag] =
    useState(false);
  const [IS_PROJECT_AFFECTED_REQUIRED, setIsProjectAffectedRequired] =
    useState(false);
  const [earthquakeAffectedFlag, setEarthquakeAffectedFlag] = useState(false);
  const [IS_EARTHQUAKE_AFFECTED_REQUIRED, setIsEarthquakeAffectedRequired] =
    useState(false);
  const [graduateEmployeeFlag, setGraduateEmployeeFlag] = useState(false);
  const [isAdditionalReservationFlag, setIsAdditionalReservationFlag] =
    useState("No");
  const [IS_GRADUATE_EMPLOYEE_REQUIRED, setIsGraduateEmployeeRequired] =
    useState(false);
  const [reloadItem, setReloadItem] = useState(0);
  const [certificateNoPa, setCertificateNoPa] = useState("");
  const [issuingDatePa, setIssuingDatePa] = useState("");
  const [certificateNoEqa, setCertificateNoEqa] = useState("");
  const [issuingDateEqa, setIssuingDateEqa] = useState("");
  const [employmentNoGpte, setEmploymentNoGpte] = useState("");
  const [issuingDateGpte, setIssuingDateGpte] = useState("");
  const [authenticatedUserData, setAuthenticatedUserData] = useState({
    dob: "",
    age: "",
    registeredEmailId: "",
    registeredMobileNo: "",
  });
  const { moduleList } = useSelector(
    (state) => state.loginReducer,
    shallowEqual
  );
  const [arraymModule, setarraymModule] = useState({});
  const [verifyHusbandNameFlag, setVerifyHusbandNameFlag] = useState(false);
  const [verifyMaritalStatusFlag, setVerifyMaritalStatusFlag] = useState(false);
  const [verifyCategoryCodeFlag, setVerifyCategoryCodeFlag] = useState(false);
  const [verifyDisabilityFlag, setVerifyDisabilityFlag] = useState(false);
  const [genderLabel, setGenderLabel] = useState("");
  const [adharLookUp, setAdharLookUp] = useState("")
  const [casteNameDropdownValue, setCasteNameDropdownValue] = useState([]);
  const [verifyPermenantResidentFlg, setVerifyPermenantResidentFlg] = useState(false);
  const [citizenshipMessage, setCitizenshipMessage] = useState(false)
  const [showName, setShowName] = useState(false);
  const [showChangedName, setShowChangedName] = useState(false);

  useEffect(() => {
    dispatch(getAllLookupOptionsAPI());
    dispatch(getPersonalInfoDigilockerStatus());
    dispatch(getPersonalInfoData());
  }, []);

  useEffect(() => {
    additionResEnvData &&
      setIsProjectAffectedRequired(additionResEnvData.projectAffectedRequired);
    additionResEnvData &&
      setIsEarthquakeAffectedRequired(
        additionResEnvData.earthquakeAffetctedRequired
      );
    additionResEnvData &&
      setIsGraduateEmployeeRequired(
        additionResEnvData.graduateEmployeeRequired
      );
    setReloadItem(!reloadItem);
  }, [additionResEnvData]);

  useEffect(() => {
    setarraymModule(
      moduleList &&
      moduleList.filter((ele) => ele.moduleName === "PERSONAL_INFO")[0]
    );
    setReloadItem(!reloadItem);
  }, [moduleList]);


  useEffect(() => {
    let profileFormDetails = profileFormDetailsData;
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let dobData = session && session.dob;
    let ageData = session && session.age;
    let registeredEmailId = session && session.emailId;
    let registeredMobileNo = session && session.mobileNumber;
    const dateOnly = profileFormDetails && profileFormDetails.dob && profileFormDetails.dob.split("T")[0];
    const finaldobData = dateOnly && dayjs(dateOnly).toDate();
    setAuthenticatedUserData({
      ...authenticatedUserData,
      dob: finaldobData && finaldobData,
      age: ageData,
      registeredEmailId: registeredEmailId,
      registeredMobileNo: registeredMobileNo,
    });

    dispatch({
      type: SET_AUTHENTICATION_DATA_OBJ,
      payload: authenticatedUserData
    })

    setIsAdditionalReservationFlag(
      profileFormDetails.isAdditionalReservation ? "Yes" : "No"
    );
    setProjectAffectedPersonFlag(profileFormDetails.isProjectAffected);
    setEarthquakeAffectedFlag(profileFormDetails.isEarthquakeAffected);
    setGraduateEmployeeFlag(profileFormDetails.isGraduateEmployee);
    setCertificateNoPa(
      profileFormDetails && profileFormDetails.certificateNoPa
    );
    setIssuingDatePa(
      profileFormDetails &&
      profileFormDetails.issuingDatePa &&
      dayjs(profileFormDetails.issuingDatePa).toDate()
    );
    setCertificateNoEqa(
      profileFormDetails && profileFormDetails.certificateNoEqa
    );
    setIssuingDateEqa(
      profileFormDetails &&
      profileFormDetails.issuingDateEqa &&
      dayjs(profileFormDetails.issuingDateEqa).toDate()
    );
    setEmploymentNoGpte(
      profileFormDetails && profileFormDetails.employmentNoGpte
    );
    setIssuingDateGpte(
      profileFormDetails &&
      profileFormDetails.issuingDateGpte &&
      dayjs(profileFormDetails.issuingDateGpte).toDate()
    );
    setSaveData(profileFormDetails);
    if (profileFormDetails) {
      setFlagOfAdharCard(
        profileFormDetails && profileFormDetails.flgAadhaarCard === true
          ? "Yes"
          : "No"
      );
      setcastCategoryBooleanState({
        castCertificateDistrict:
          profileFormDetails && profileFormDetails.ccIssuingDistrictLookupId,
        doYouBelongToNonCreamyLayer:
          profileFormDetails && profileFormDetails.flgNcl != null
            ? profileFormDetails.flgNcl === true
              ? "Yes"
              : "No"
            : "",
        doYouHaveCastValidityCertificate:
          profileFormDetails && profileFormDetails.flgCastValidityCert != null
            ? profileFormDetails &&
              profileFormDetails.flgCastValidityCert == true
              ? "Yes"
              : "No"
            : "",
      });
      setCastType({
        castType: profileFormDetails && profileFormDetails.categoryLookupId,
      });
      shownotConsiderUnreservedcategoryForCastValidity(
        profileFormDetails && profileFormDetails.flgUnreservedCastValidity
      );
      setSportsBooleanState({
  isMetritoriousSportsman: profileFormDetails?.isMetritoriousSportsman === true ? "Yes" : profileFormDetails?.isMetritoriousSportsman === false ? "No" : null,
});

      setExServiceManBooleanState({
        flgExArmedReg:
          profileFormDetails && profileFormDetails.flgExArmedReg != null
            ? profileFormDetails.flgExArmedReg == true
              ? "Yes"
              : "No"
            : "",
        exServiceManDivision:
          profileFormDetails && profileFormDetails.exServiceManDivision,
      });

      setGovOfMaharashtraEmpDetail({
        flgGomEmployee:
          profileFormDetails && profileFormDetails.flgGomEmployee != null
            ? profileFormDetails.flgGomEmployee == true
              ? "Yes"
              : "No"
            : "",
        flgBmcEmployee:
          profileFormDetails && profileFormDetails.flgBmcEmployee != null
            ? profileFormDetails.flgBmcEmployee == true
              ? "Yes"
              : "No"
            : "",
        flgBestEmployee:
          profileFormDetails && profileFormDetails.flgBestEmployee != null
            ? profileFormDetails.flgBestEmployee == true
              ? "Yes"
              : "No"
            : "",
        flgStateEmployee:
          profileFormDetails && profileFormDetails.flgStateEmployee != null
            ? profileFormDetails.flgStateEmployee == true
              ? "Yes"
              : "No"
            : "",
      });

     setDomicileDetails({
  maharashtraDomicileCertificate: profileFormDetails?.flgDomicile === true ? "Yes" : profileFormDetails?.flgDomicile === false ? "No" : "",
  domicileIssuingDistrict: profileFormDetails?.domicileIssuingDistrict,
  domicileCertificateAvailable: profileFormDetails?.flgDomicileCertificate === true ? "Yes" : profileFormDetails?.flgDomicileCertificate === false ? "No" : "",
});

      setDatePiker({
        dateOfBirth:
          profileFormDetails &&
          profileFormDetails.dob &&
          dayjs(profileFormDetails.dob).toDate(),
        castCertiIssuingDate:
          profileFormDetails &&
          profileFormDetails.castCertiIssuingDate &&
          dayjs(profileFormDetails.castCertiIssuingDate).toDate(),
        latestNclIssueDate:
          profileFormDetails &&
          profileFormDetails.latestNclIssueDate &&
          dayjs(profileFormDetails.latestNclIssueDate).toDate(),
        castValidityCertIssueDate:
          profileFormDetails &&
          profileFormDetails.castValidityCertIssueDate &&
          dayjs(profileFormDetails.castValidityCertIssueDate).toDate(),
        sadmCertificateDate:
          profileFormDetails &&
          profileFormDetails.sadmCertificateDate &&
          dayjs(profileFormDetails.sadmCertificateDate).toDate(),
        dateApptArmedRegular:
          profileFormDetails &&
          profileFormDetails.dateApptArmedRegular &&
          dayjs(profileFormDetails.dateApptArmedRegular).toDate(),
        ageRelaxCertiNo1:
          profileFormDetails &&
          profileFormDetails.ageRelaxCertiNo1 &&
          dayjs(profileFormDetails.ageRelaxCertiNo1).toDate(),
        dateDischargeArmedRegular:
          profileFormDetails &&
          profileFormDetails.dateDischargeArmedRegular &&
          dayjs(profileFormDetails.dateDischargeArmedRegular).toDate(),
        dateRetireArmedRegular:
          profileFormDetails &&
          profileFormDetails.dateRetireArmedRegular &&
          dayjs(profileFormDetails.dateRetireArmedRegular).toDate(),
        domicileIssuingDate:
          profileFormDetails &&
          profileFormDetails.domicileIssuingDate &&
          dayjs(profileFormDetails.domicileIssuingDate).toDate(),
        orphanCertiAckReceiptDate:
          profileFormDetails &&
          profileFormDetails.orphanCertiAckReceiptDate &&
          dayjs(profileFormDetails.orphanCertiAckReceiptDate).toDate(),
        orphanCertiIssueDate:
          profileFormDetails &&
          profileFormDetails.orphanCertiIssueDate &&
          dayjs(profileFormDetails.orphanCertiIssueDate).toDate(),
        exServiceYears: profileFormDetails && profileFormDetails.exServiceYears,
        exServiceMonths:
          profileFormDetails && profileFormDetails.exServiceMonths,
        exServiceDays: profileFormDetails && profileFormDetails.exServiceDays,
        ccIssuingDate:
          profileFormDetails &&
          profileFormDetails.ccIssuingDate &&
          dayjs(profileFormDetails.ccIssuingDate).toDate(),
        ffcIssuingDate:
          profileFormDetails &&
          profileFormDetails.ffcIssuingDate &&
          dayjs(profileFormDetails.ffcIssuingDate).toDate(),
        ncccIssuingDate:
          profileFormDetails &&
          profileFormDetails.ncccIssuingDate &&
          dayjs(profileFormDetails.ncccIssuingDate).toDate(),
        nccToDate:
          profileFormDetails &&
          profileFormDetails.nccToDate &&
          dayjs(profileFormDetails.nccToDate).toDate(),
        exServiceManToDate:
          profileFormDetails &&
          profileFormDetails.exServiceManToDate &&
          dayjs(profileFormDetails.exServiceManToDate).toDate(),
      });
      setPersonalDetail({
        gender: profileFormDetails && profileFormDetails.genderLookupId,
        maritalStatusLookupId:
          profileFormDetails && profileFormDetails.maritalStatusLookupId,
        verifymaritalStatusLookupId:
          profileFormDetails && profileFormDetails.maritalStatusLookupId,
        flgCandidateLiable:
          profileFormDetails && profileFormDetails.flgCandidateLiable != null
            ? profileFormDetails.flgCandidateLiable
              ? "Yes"
              : "No"
            : "",
        Nationality:
          profileFormDetails && profileFormDetails.nationalityLookupId,
        motherTongue: profileFormDetails?.motherTongueLookupId,
        canYouRead: profileFormDetails?.flgMarathiRead === true ? "Yes" : profileFormDetails?.flgMarathiRead === false ? "No" : null,
        canYouWrite: profileFormDetails?.flgMarathiWrite === true ? "Yes" : profileFormDetails?.flgMarathiWrite === false ? "No" : null,
        canYouSpeak: profileFormDetails?.flgMarathiSpeak === true ? "Yes" : profileFormDetails?.flgMarathiSpeak === false ? "No" : null,
        flg_candidate_liable: profileFormDetails?.flg_candidate_liable === true ? "Yes" : profileFormDetails?.flg_candidate_liable === false ? "No" : null,
        isNameChanged: profileFormDetails?.isNameChanged === true ? "Yes" : profileFormDetails?.isNameChanged === false ? "No" : null,
        nationalityLookupId:profileFormDetails && profileFormDetails.nationalityLookupId == true ? "Yes" : profileFormDetails.nationalityLookupId == false  ? "No" : null,
        isDomicile: profileFormDetails?.isDomicile === true ? "Yes" : profileFormDetails?.isDomicile === false ? "No" : null,
        isVerifiedDomicile: profileFormDetails?.isDomicile === true ? "Yes" : profileFormDetails?.isDomicile === false ? "No" : null,
        isReservedCategory: profileFormDetails?.isReservedCategory === true ? "Yes" : profileFormDetails?.isReservedCategory === false ? "No" : null,
        ccIssuingDistrict: profileFormDetails?.ccIssuingDistrict ? "Yes" : profileFormDetails?.ccIssuingDistrict === "" ? "No" : null,
        idTypeLookupId:
          profileFormDetails && profileFormDetails.idTypeLookupId
            ? profileFormDetails.idTypeLookupId
            : "",
        idNumber:
          profileFormDetails && profileFormDetails.idNumber
            ? profileFormDetails.idNumber
            : "",
        categoryLookupId:
          profileFormDetails && profileFormDetails.categoryLookupId
            ? profileFormDetails.categoryLookupId
            : "",
        verifyCategoryLookupId:
          profileFormDetails && profileFormDetails.categoryLookupId
            ? profileFormDetails.categoryLookupId
            : "",
        castenameLookupId:
          profileFormDetails && profileFormDetails.castenameLookupId
            ? profileFormDetails.castenameLookupId
            : "",
        isCcIssuedByBihar: profileFormDetails?.isCcIssuedByBihar === true ? "Yes" : profileFormDetails?.isCcIssuedByBihar === false ? "No" : null,
        isFfGrandchild: profileFormDetails?.isFfGrandchild === true ? "Yes" : profileFormDetails?.isFfGrandchild === false ? "No" : null,
        isDivyang: profileFormDetails?.isDivyang === true ? "Yes" : profileFormDetails?.isDivyang === false ? "No" : null,

        divyangPercentage:
          profileFormDetails && profileFormDetails.divyangPercentage
            ? profileFormDetails.divyangPercentage
            : "",
        isDisabilityScribeReq: profileFormDetails?.isDisabilityScribeReq === true ? "Yes" : profileFormDetails?.isDisabilityScribeReq === false ? "No" : null,

        typeOfDisabilityLookupId:
          profileFormDetails && profileFormDetails.typeOfDisabilityLookupId
            ? profileFormDetails.typeOfDisabilityLookupId
            : "",
        verifiedNatureOfDivyang:
          profileFormDetails && profileFormDetails.typeOfDisabilityLookupId
            ? profileFormDetails.typeOfDisabilityLookupId
            : "",
        dbcIssuingInstituteLookupId:
          profileFormDetails && profileFormDetails.dbcIssuingInstituteLookupId
            ? profileFormDetails.dbcIssuingInstituteLookupId
            : "",
        isExArmedReg: profileFormDetails?.isExArmedReg === true ? "Yes" : profileFormDetails?.isExArmedReg === false ? "No" : null,
        isNccCadet: profileFormDetails?.isNccCadet === true ? "Yes" : profileFormDetails?.isNccCadet === false ? "No" : null,
        isGobEmployee: profileFormDetails?.isGobEmployee === true ? "Yes" : profileFormDetails?.isGobEmployee === false ? "No" : null,

        jobDesignation:
          profileFormDetails && profileFormDetails.jobLookupId
            ? profileFormDetails.jobLookupId
            : "",
      });
      if (profileFormDetails && profileFormDetails.jobDesignation) {
        setJobNatureLabel(profileFormDetails.jobDesignation)
      }
      setDivyangDetails({
        areYouDivyangjan:
          profileFormDetails && profileFormDetails.flgDivyang != null
            ? profileFormDetails.flgDivyang == true
              ? "Yes"
              : "No"
            : "",
        typeOfDisabilityLookupId:
          profileFormDetails && profileFormDetails.typeOfDisabilityLookupId,
        typeDisabilityCertificate:
          profileFormDetails && profileFormDetails.typeDisabilityCertificate,
        disabilitySubCategoriesLookupIdsList:
          profileFormDetails &&
          profileFormDetails.disabilitySubCategoriesLookupIdsList,
        areYouHaveUDID:
          profileFormDetails && profileFormDetails.udid
            ? "Yes"
            : profileFormDetails.udidEnrolmentNo &&
              profileFormDetails.udidEnrolmentNo
              ? "No"
              : "",
        udid:
          profileFormDetails && profileFormDetails.udid
            ? profileFormDetails.udid
            : "",
        udidEnrolmentNo:
          profileFormDetails && profileFormDetails.udidEnrolmentNo
            ? profileFormDetails.udidEnrolmentNo
            : "",
      });
      /** OAS-640 Border Area Changes */

      setBorderAreaDetails({
        borderDistrictLookupId:
          profileFormDetails && profileFormDetails.borderDistrictLookupId,
        borderTalukaLookupId:
          profileFormDetails && profileFormDetails.borderTalukaLookupId,
        borderVillageLookupId:
          profileFormDetails && profileFormDetails.borderVillageLookupId,
      });

      setFlgMaharashtraKarnatakBorderArea(
        profileFormDetails &&
          profileFormDetails.flgMaharashtraKarnatakBorderArea === true
          ? "Yes"
          : "No"
      );
      setFlgTransgenderFemale(
        profileFormDetails && profileFormDetails.flgTransgenderFemale === true
          ? "Yes"
          : "No"
      );
      /** OAS-640 Border Area Changes */

      setOrphanDetails({
        DoYouWantTotakeAvantageOfOrphan:
          profileFormDetails && profileFormDetails.flgOrphanReservation != null
            ? profileFormDetails.flgOrphanReservation === true
              ? "Yes"
              : "No"
            : "",
        OrphanCertificateNumber:
          profileFormDetails && profileFormDetails.orphanReservationCertiNo,
        orphanType: profileFormDetails && profileFormDetails.orphanType,
      });
      setFlgDisabilityPensionHolder(
        profileFormDetails.flgDisabilityPensionHolder ? "Yes" : "No"
      );
      dispatch(
        setSportsDetails(profileFormDetails.meritoriousSportsmanDtoList)
      );
    }
    setReloadItem(!reloadItem);
  }, [profileFormDetailsData]);

  useEffect(() => {
    let storedDisabilityLookupId = DivyangDetails.typeOfDisabilityLookupId;
    let currentDisabilitySubCategories =
      allDisabilitiesData &&
      allDisabilitiesData.length > 0 &&
      allDisabilitiesData.filter((subCat) => {
        return Number(subCat.parentId) === Number(storedDisabilityLookupId);
      });
    setDisabilitySubCategoriesOptions(currentDisabilitySubCategories);
    let savedDisabilitySubCategoriesLookupIds =
      DivyangDetails.disabilitySubCategoriesLookupIdsList
        ? DivyangDetails.disabilitySubCategoriesLookupIdsList
        : [];
    let savedSubcategoryOptions = [];
    for (let i = 0; i < savedDisabilitySubCategoriesLookupIds.length; i++) {
      let savedId = savedDisabilitySubCategoriesLookupIds[i];
      let savedSubCat =
        currentDisabilitySubCategories &&
        currentDisabilitySubCategories.find((subCat) => {
          return Number(subCat.id) === Number(savedId);
        });
      if (savedSubCat) {
        savedSubcategoryOptions.push({
          id: savedSubCat.id,
          label: savedSubCat.label,
          isFixed: mandatoryMultipleDisabilitySubCats.includes(savedSubCat.id),
          isRequired: savedSubCat.isRequired,
        });
      }
    }
    let selectedOptions;
    if (Number(DivyangDetails.typeOfDisabilityLookupId) !== multiSelectCatId) {
      selectedOptions = savedSubcategoryOptions[0];
    } else {
      selectedOptions = savedSubcategoryOptions;
    }
    setDisabilitySubCategoriesLookupIds(selectedOptions);
    const listOfAllBorderTalukasLocal = getLookOptionsForADropdown(
      "maha_karnatak_border_taluka",
      profileCreationAllLookupData
    );
    const listOfAllBorderVillagesLocal = getLookOptionsForADropdown(
      "maha_karnatak_border_village",
      profileCreationAllLookupData
    );
    let borderTalukaOptionsForSavedDistrict = [];
    let borderVillageOptionsForSavedDistrict = [];
    borderTalukaOptionsForSavedDistrict =
      listOfAllBorderTalukasLocal &&
      listOfAllBorderTalukasLocal.filter((taluka) => {
        return (
          Number(taluka.parentId) ===
          Number(borderAreaDetails.borderDistrictLookupId)
        );
      });
    borderVillageOptionsForSavedDistrict =
      listOfAllBorderVillagesLocal &&
      listOfAllBorderVillagesLocal.filter((village) => {
        return (
          Number(village.parentId) ===
          Number(borderAreaDetails.borderTalukaLookupId)
        );
      });
    setBorderTalukaOptions(borderTalukaOptionsForSavedDistrict);
    setBorderVillageOptions(borderVillageOptionsForSavedDistrict);
    setReloadItem(!reloadItem);
  }, [profileCreationAllLookupData.length]);

  const dispatch = useDispatch();
  const { register, handleSubmit, errors, control, watch, setValue } = useForm({
    mode: "onChange",
  });

  let genderLookupId = watch("gender");
  let maritalStatusId = watch("maritalStatusLookupId");
  let [maritalStatusLabel, setMaritalStatusLabel] = useState("");

  useEffect(() => {
    if (
      allLookUpList &&
      allLookUpList.lookupOptionDtoList &&
      allLookUpList.lookupOptionDtoList.filter((ele) => ele.type === "gender")
    ) {
      const matchedItem = allLookUpList.lookupOptionDtoList.find(
        (item) => item.id == genderLookupId
      );
      if (matchedItem && matchedItem) {
        setGenderLabel(matchedItem.label);
      } else {
        setGenderLabel("");
      }
    }

    if (
      allLookUpList &&
      allLookUpList.lookupOptionDtoList &&
      allLookUpList.lookupOptionDtoList.length > 0 &&
      allLookUpList.lookupOptionDtoList.filter((ele) => ele.type === "id_type")
    ) {
      const matchedItem = allLookUpList.lookupOptionDtoList
        .filter((ele) => ele.type === "marital_status")
        .find((item) => item.id == maritalStatusId);
      if (matchedItem && matchedItem) {
        setMaritalStatusLabel(matchedItem.label);
      } else {
        setMaritalStatusLabel("");
      }
    }
  }, [
    genderLookupId,
    maritalStatusId,
    allLookUpList && allLookUpList.lookupOptionDtoList,
  ]);

  const onSubmit = (data, e) => {
    if (data.nationalityLookupId?.trim().toLowerCase() !== "yes") {
      toastr.warning("Please make sure you have Indian citizenship");
      return;
    }

    let requestBody = {};

    requestBody.englishFullName =
      personal_info_form && personal_info_form.englishFullName && personal_info_form.englishFullName.toUpperCase();
    requestBody.devnagariFullName = data.devnagariFullName;
    requestBody.motherName =
      personal_info_form && personal_info_form.motherName && personal_info_form.motherName.toUpperCase();
    requestBody.fatherName =
      personal_info_form && personal_info_form.fatherName && personal_info_form.fatherName.toUpperCase();
    requestBody.maritalStatusLookupId = data.verifymaritalStatusLookupId;
    requestBody.husbandName = data.verifiedHusbandName && data.verifiedHusbandName.toUpperCase();
    requestBody.dob = datePickerData.dob;
    requestBody.genderLookupId = personalDetails.gender;
    requestBody.idTypeLookupId = data.idTypeLookupId;
    // requestBody.idNumber = data.idNumber;
    requestBody.identificationMark = data.identificationMark && data.identificationMark.toUpperCase();
    requestBody.changedEnglishName = data.changedEnglishName && data.changedEnglishName.toUpperCase();
    requestBody.isNameChanged = data.isNameChanged && data.isNameChanged === "Yes" ? true : false;
    requestBody.isDomicile = data.isVerifiedDomicile === "Yes" ? true : false;
    requestBody.domicileCertificateNo = data.domicileCertificateNo && data.domicileCertificateNo.toUpperCase();
    requestBody.domicileIssuingDate = data.domicileIssuingDate;
    requestBody.domicileIssuingDate = data.domicileIssuingDate;
    requestBody.nationalityLookupId =
      data.nationalityLookupId === "Yes" ? true : false;
    requestBody.isReservedCategory =
      data.isReservedCategory === "Yes" ? true : false;
    requestBody.categoryLookupId = data.categoryLookupId;
    requestBody.castenameLookupId = personalDetails.castenameLookupId;
    requestBody.casteCertificateNo = data.casteCertificateNo && data.casteCertificateNo.toUpperCase();
    requestBody.ccIssuingDate = data.ccIssuingDate;

    requestBody.isCcIssuedByBihar =
      data.isCcIssuedByBihar === "Yes" ? true : false;
    requestBody.isFfGrandchild = data.isFfGrandchild === "Yes" ? true : false;
    requestBody.ffcNumber = data.ffcNumber && data.ffcNumber.toUpperCase();
    requestBody.ffcIssuingDate = data.ffcIssuingDate;
    requestBody.isDivyang = data.isDivyang === "Yes" ? true : false;
    requestBody.isDisabilityScribeReq = data.isDisabilityScribeReq === "Yes" ? true : false;
    requestBody.typeOfDisabilityLookupId = data.verifiedNatureOfDivyang;
    requestBody.sadmCertificateNumber = data.sadmCertificateNumber && data.sadmCertificateNumber.toUpperCase();
    requestBody.divyangPercentage = data.divyangPercentage && data.divyangPercentage;
    requestBody.sadmCertificateDate = data.sadmCertificateDate;
    requestBody.dbcIssuingInstituteLookupId = data.dbcIssuingInstituteLookupId;
    requestBody.isMetritoriousSportsman =
      data.isMetritoriousSportsman === "Yes" ? true : false;
    requestBody.isExArmedReg = data.isExArmedReg === "Yes" ? true : false;
    requestBody.dischargeCertificateNo = data.dischargeCertificateNo && data.dischargeCertificateNo.toUpperCase();
    requestBody.dateDischargeArmedRegular = data.dateDischargeArmedRegular;
    requestBody.exServiceManToDate = data.exServiceManToDate;
    requestBody.isNccCadet = data.isNccCadet === "Yes" ? true : false;
    requestBody.nccCertificateNo = data.nccCertificateNo && data.nccCertificateNo.toUpperCase();
    requestBody.ncccIssuingDate = data.ncccIssuingDate;
    requestBody.nccToDate = data.nccToDate;
    requestBody.isGobEmployee = data.isGobEmployee === "Yes" ? true : false;
    requestBody.jobLookupId = data.jobDesignation;
    requestBody.jobDesignation = jobNatureLabel;
    requestBody.jobOffice = data.jobOffice && data.jobOffice.toUpperCase();
    requestBody.jobPlace = data.jobPlace && data.jobPlace.toUpperCase();
    requestBody.idNumber = data.idNumber && data.idNumber.toUpperCase();
    requestBody.height = data.HeightInCMS ? data.HeightInCMS.trim() : null,
      requestBody.weight = data.Weight ? data.Weight.trim() : null,
      requestBody.chestDeflated = data.chestDeflated ? data.chestDeflated.trim() : null,
      requestBody.chestInflated = data.chestInflated ? data.chestInflated.trim() : null
    const updatedData = meritoriousSportsmanDtoList && meritoriousSportsmanDtoList.map(item => ({
      ...item,
      acknowledgementNumber: item.acknowledgementNumber
        ? item.acknowledgementNumber.toUpperCase()
        : '',
      sportsCertiReportNo: item.sportsCertiReportNo ? item.sportsCertiReportNo.toUpperCase() : ''
    }));
    requestBody.meritoriousSportsmanDtoList = updatedData;


    if (data.isNameChanged === "NO") {
      requestBody.changedEnglishName = "";
    }


    if (data.isReservedCategory === "NO") {
      requestBody.categoryLookupId = "";
      requestBody.castenameLookupId = "";
      requestBody.casteCertificateNo = "";
      requestBody.ccIssuingDate = "";
    }

    if (data.isFfGrandchild === "NO") {
      requestBody.ffcNumber = "";
      requestBody.ffcIssuingDate = "";
    }

    if (data.isDivyang === "NO") {
      requestBody.typeOfDisabilityLookupId = "";
      requestBody.sadmCertificateNumber = "";
      requestBody.sadmCertificateDate = "",
        requestBody.divyangPercentage = "",
        requestBody.dbcIssuingInstituteLookupId = ""
    }

    if (data.isVerifiedDomicile === "NO") {
      requestBody.domicileCertificateNo = "";
      requestBody.domicileIssuingDate = ""
    }

    if (data.isExArmedReg === "NO") {
      requestBody.dischargeCertificateNo = "";
      requestBody.dateDischargeArmedRegular = "";
      requestBody.exServiceManToDate = ""
    }


    if (data.isNccCadet === "NO") {
      requestBody.nccCertificateNo = "";
      requestBody.ncccIssuingDate = "";
      requestBody.nccToDate = ""
    }

    if (data.isGobEmployee === "NO") {
      requestBody.jobDesignation = "";
      requestBody.jobOffice = "";
      requestBody.jobPlace = ""
    }

    if (data.isDomicile === "NO" && data.isVerifiedDomicile === "NO") {
      requestBody.domicileCertificateNo = "";
      requestBody.domicileIssuingDate = ""

      requestBody.categoryLookupId = "";
      requestBody.castenameLookupId = "";
      requestBody.casteCertificateNo = "";
      requestBody.ccIssuingDate = "";

      requestBody.ffcNumber = "";
      requestBody.ffcIssuingDate = "";
    }


    let sportsList = [];
    meritoriousSportsmanDtoList &&
      meritoriousSportsmanDtoList.length > 0 &&
      meritoriousSportsmanDtoList.forEach((ele) => {
        if (!ele.isDeleted) {
          sportsList.push(ele);
        }
      });

    dispatch(clearSportForm(true));
    dispatch(savePersonalInfoData(requestBody));
    setReloadItem(!reloadItem);
  };


  const gender = watch("gender");
  const idTypeLookupId = watch("idTypeLookupId");
  const idNumber = watch("idNumber");
  const [idTypeLabel, setIdTypeLabel] = useState("");
  const castListOption = watch("castType");
  let [flgTransgenderFemale, setFlgTransgenderFemale] = useState("No");
  const [categoryCodeLabel, setCategoryCodeLabel] = useState('');
  const [jobNatureLabel, setJobNatureLabel] = useState('');

  useEffect(() => {
    if (gender || castListOption) {
      setShowEWS(false);
      if (castListOption != "323") {
        shownotConsiderUnreservedcategoryForCastValidity(false);
      }
      if (
        (gender == "321" ||
          (Number(gender) === commonENLabels.DATABASE_VALUES.THIRD_GENDER_LOOKUP_ID && flgTransgenderFemale === "Yes")) &&
        castListOption == "323"
      ) {
        setHideNCL(true);
        setHideCastCertificate(false);
        setHideCastValidity(false);
      } else if (
        (gender == commonENLabels.DATABASE_VALUES.FEMALE_GENDER_LOOKUP_ID ||
          (Number(gender) === commonENLabels.DATABASE_VALUES.THIRD_GENDER_LOOKUP_ID && flgTransgenderFemale === "No") ||
          gender == "") &&
        castListOption == "323"
      ) {
        setHideNCL(false);
        setHideCastCertificate(false);
        setHideCastValidity(false);
      } else if (castListOption == "324" || castListOption == "325") {
        setHideNCL(false);
        setHideCastCertificate(true);
        setHideCastValidity(true);
      } else if (
        castListOption === "326" ||
        castListOption === "327" ||
        castListOption === commonENLabels.DATABASE_VALUES.MALE_GENDER_LOOKUP_ID ||
        castListOption === commonENLabels.DATABASE_VALUES.FEMALE_GENDER_LOOKUP_ID ||
        castListOption === commonENLabels.DATABASE_VALUES.THIRD_GENDER_LOOKUP_ID ||
        castListOption === "331" ||
        castListOption === "333"
      ) {
        setHideCastCertificate(true);
        setHideCastValidity(true);
        setHideNCL(true);
      } else if (castListOption === "332") {
        setShowEWS(true);
        setHideCastCertificate(false);
        setHideNCL(false);
        setHideCastValidity(false);
      } else {
        setHideCastCertificate(false);
        setHideNCL(false);
        setHideCastValidity(false);
      }
    }
    setReloadItem(!reloadItem);
  }, [gender, castListOption, flgTransgenderFemale]);

  const [isAdharCardPresentFlag, setFlagOfAdharCard] = useState("Yes");
  const [flgDisabilityPensionHolder, setFlgDisabilityPensionHolder] =
    useState("Yes");
  // Have you joined State Govt
  const [castCategoryBooleanState, setcastCategoryBooleanState] = useState({
    castCertificateDistrict: "",
    doYouBelongToNonCreamyLayer: "",
  });
  const [castTypeSelection, setCastType] = useState({
    castType: "",
  });
  const [SportsBooleanState, setSportsBooleanState] = useState({
    isMetritoriousSportsman: "Yes",
  });

  const [ExServiceManBooleanState, setExServiceManBooleanState] = useState({
    flgExArmedReg: "",
    exServiceManDivision: "",
  });

  const [govOfMaharashtraEmpDetail, setGovOfMaharashtraEmpDetail] = useState({
    flgGomEmployee: "",
    flgBmcEmployee: "",
    flgBestEmployee: "",
    flgStateEmployee: "",
  });




  const [DomicileDetailsBooleanState, setDomicileDetails] = useState({
    maharashtraDomicileCertificate: "",
    domicileIssuingDistrict: "",
    domicileCertificateAvailable: "",
  });

  const [personalDetails, setPersonalDetail] = useState({
    gender: "",
    maritalStatusLookupId: "",
    verifymaritalStatusLookupId: "",
    Nationality: "",
    motherTongue: "",
    canYouRead: "Yes",
    canYouWrite: "Yes",
    canYouSpeak: "Yes",
    flgCandidateLiable: "",
    nationalityLookupId: "Yes",
    isDomicile: "Yes",
    isDomicileVerified: "Yes",
    isVerifiedDomicile: "Yes",
    isReservedCategory: "Yes",
    ccIssuingDistrict: "Yes",
    idTypeLookupId: "",
    idNumber: "",
    categoryLookupId: "",
    verifyCategoryLookupId: "",
    castenameLookupId: "",
    isCcIssuedByBihar: "Yes",
    isFfGrandchild: "Yes",
    isDivyang: "Yes",
    isDisabilityScribeReq: "Yes",
    typeOfDisabilityLookupId: "",
    verifiedNatureOfDivyang: "",
    dbcIssuingInstituteLookupId: "",
    isExArmedReg: "Yes",
    isNccCadet: "Yes",
    isGobEmployee: "Yes",
    jobDesignation: "",
    adharLookUp: "",
    divyangPercentage: "",
    isNameChanged: "Yes",
  });

  const [DivyangDetails, setDivyangDetails] = useState({
    areYouDivyangjan: false,
    typeOfDisabilityLookupId: "",
    typeDisabilityCertificate: "",
    areYouHaveUDID: "",
    udid: "",
    udidEnrolmentNo: "",
    disabilitySubCategoriesLookupIdsList: [],
  });

  const [orphanDetails, setOrphanDetails] = useState({
    DoYouWantTotakeAvantageOfOrphan: "",
    OrphanCertificateNumber: "",
    orphanCertiIssueDate: "",
    orphanType: "",
  });
  const [datePickerData, setDatePiker] = useState({
    dateOfBirth: "",
    ageRelaxCertiNo1: "",
    castCertiIssuingDate: "",
    castValidityCertIssueDate: "",
    dateApptArmedRegular: "",
    dateDischargeArmedRegular: "",
    exServiceManToDate: "",
    dateRetireArmedRegular: "",
    domicileIssuingDate: "",
    latestNclIssueDate: "",
    orphanCertiAckReceiptDate: "",
    orphanCertiIssueDate: "",
    sadmCertificateDate: "",
    sportsCertiReportDate: "",
    exServiceYears: "",
    exServiceMonths: "",
    exServiceDays: "",
    issuingDatePa: "",
    issuingDateEqa: "",
    issuingDateGpte: "",
    ccIssuingDate: "",
    ffcIssuingDate: "",
    ncccIssuingDate: "",
    nccToDate: "",
  });

  const [
    flgUnreservedCastValidity,
    shownotConsiderUnreservedcategoryForCastValidity,
  ] = useState(false);

  const handleSportsPersonalInfoBooleanState = (evt) => {
    dispatch(clearSportForm(true));
    const value = evt.target.value;
    setSportsBooleanState({
      ...SportsBooleanState,
      [evt.target.name]: value,
    });

    let meritoriousSportsmanDto = meritoriousSportsmanDtoList;
    if (value === "No") {
      dispatch(clearSportForm(true));
      meritoriousSportsmanDto &&
        meritoriousSportsmanDto.length > 0 &&
        meritoriousSportsmanDto.forEach((ele, index) => {
          if (ele.id) {
            ele.isDeleted = true;
          } else {
            meritoriousSportsmanDto.splice(index, 1);
          }
        });
    }
    dispatch(setSportsDetails(meritoriousSportsmanDto));
    setReloadItem(!reloadItem);
  };

  useEffect(() => {
    if (watch("isDomicile") === watch("isVerifiedDomicile")) {
      setVerifyPermenantResidentFlg(false);
    } else {
      setVerifyPermenantResidentFlg(true);
    }
  }, [watch("isDomicile"), watch("isVerifiedDomicile")]);

  const handlePersonalDetailsDropdown = (evt) => {
    const value = evt.target.value;

    // if (evt.target.name.trim() == "isCcIssuedByBihar" && value == "No") {
    //   toastr.warning(commonENLabels.ISSUED_BY_BIHAR_WARNING);
    // }

    if (evt.target.name === "nationalityLookupId" && value === "No") {
      dispatch({
        type: SET_CITIZENSHIP_WARNING_MSG,
        payload: commonENLabels.CITIZENSIP_WARNING
      })
      popupName()
      setCitizenshipMessage(commonENLabels.CITIZENSIP_WARNING_LINE_1)
      // toastr.warning(commonENLabels.CITIZENSIP_WARNING)
    }

    if (evt.target.name === "isNameChanged") {
      if (value === "Yes") {
        setShowChangedName(true)
        setSaveData({
          ...personal_info_form,
          ["changedEnglishName"]: "",
        });
        setValue("changedEnglishName", "");
      } else {
        setShowChangedName(false)
      }
    }

    if (evt.target.name === "idNumber") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
      })
    }
    if (evt.target.name === "categoryLookupId") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["verifyCategoryLookupId"]: "",
        ["casteCertificateNo"]: "",
        ["ccIssuingDate"]: "",
        ["castenameLookupId"]: "",
        // ["categoryLookupId"]: "",

      });
      setDatePiker({
        ...datePickerData,
        ccIssuingDate: "",
      });
      setSaveData({
        ...personal_info_form,
        ["casteCertificateNo"]: "",
      });
      if (evt.target.name === "divyangPercentage") {
        setSaveData({
          ...personal_info_form,
          ["divyangPercentage"]: value,
        });
      }
      if (evt.target.name === "isNameChanged" && value === "No") {
        setSaveData({
          ...personal_info_form,
          ["changedEnglishName"]: "",
        });
      } else {
        setSaveData({
          ...personal_info_form,
          ["changedEnglishName"]: value,
        });
      }
      setSaveData({
        ...personal_info_form,
        ["isNameChanged"]: value,
      });
      setValue("casteCertificateNo", "");
      setValue("ccIssuingDate", "");
      setCategoryCodeLabel('');
    }

    else if (evt.target.name === "verifyCategoryLookupId") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["casteCertificateNo"]: "",
        ["ccIssuingDate"]: ""
      });
      setDatePiker({
        ...datePickerData,
        ccIssuingDate: "",
      });
      setSaveData({
        ...personal_info_form,
        ["casteCertificateNo"]: "",
      });
      setValue("casteCertificateNo", "");
      setValue("ccIssuingDate", "");
    }
    else if (evt.target.name === "typeOfDisabilityLookupId") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["verifiedNatureOfDivyang"]: "",
      });
    }
    else if (evt.target.name === "isVerifiedDomicile") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["domicileCertificateNo"]: "",
      });
      setDatePiker({
        ...datePickerData,
        domicileIssuingDate: "",
      });
      setSaveData({
        ...personal_info_form,
        ["domicileCertificateNo"]: "",
      });
      setValue("domicileCertificateNo", "");
      setValue("domicileIssuingDate", "");
    }
    else if (evt.target.name === "isReservedCategory") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["categoryLookupId"]: "",
        ["verifyCategoryLookupId"]: "",
        ["castenameLookupId"]: "",
        ["casteCertificateNo"]: "",
        ["isCcIssuedByBihar"]: null
      });
      setDatePiker({
        ...datePickerData,
        ccIssuingDate: "",
      });
      setSaveData({
        ...personal_info_form,
        ["casteCertificateNo"]: "",
      });
      setValue("categoryLookupId", "");
      setValue("verifyCategoryLookupId", "");
      setValue("castenameLookupId", "");
      setValue("casteCertificateNo", "");
      setValue("ccIssuingDate", "");
      setValue("isCcIssuedByBihar", null);
    }
    else if (evt.target.name === "isFfGrandchild") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["ffcNumber"]: "",
      });
      setDatePiker({
        ...datePickerData,
        ffcIssuingDate: "",
      });
      setSaveData({
        ...personal_info_form,
        ["ffcNumber"]: "",
      });
      setValue("ffcNumber", "");
      setValue("ffcIssuingDate", "");
    }
    else if (evt.target.name === "isDivyang") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["typeOfDisabilityLookupId"]: "",
        ["verifiedNatureOfDivyang"]: "",
        ["sadmCertificateNumber"]: "",
        ["dbcIssuingInstituteLookupId"]: "",
        ["divyangPercentage"]: "",
        ["isDisabilityScribeReq"]: value === "No" ? "No" : "No"
      });
      setDatePiker({
        ...datePickerData,
        sadmCertificateDate: "",
      });
      setSaveData({
        ...personal_info_form,
        ["sadmCertificateNumber"]: "",
        // ["divyangPercentage"]: ""
      });
      setValue("typeOfDisabilityLookupId", "");
      setValue("verifiedNatureOfDivyang", "");
      setValue("sadmCertificateNumber", "");
      // setValue("divyangPercentage", "");
      setValue("sadmCertificateDate", "");
      setValue("dbcIssuingInstituteLookupId", "");
    }
    else if (evt.target.name === "isExArmedReg") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["dischargeCertificateNo"]: "",
      });
      setDatePiker({
        ...datePickerData,
        dateDischargeArmedRegular: "",
        exServiceManToDate: "",
      });
      setSaveData({
        ...personal_info_form,
        ["dischargeCertificateNo"]: "",
      });
      setValue("dischargeCertificateNo", "");
      setValue("dateDischargeArmedRegular", "");
      setValue("exServiceManToDate", "");
    }
    else if (evt.target.name === "isNccCadet") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["nccCertificateNo"]: "",
      });
      setDatePiker({
        ...datePickerData,
        ncccIssuingDate: "",
        nccToDate: "",
      });
      setSaveData({
        ...personal_info_form,
        ["nccCertificateNo"]: "",
      });
      setValue("nccCertificateNo", "");
      setValue("ncccIssuingDate", "");
      setValue("nccToDate", "");
    }
    else if (evt.target.name === "isGobEmployee") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["jobDesignation"]: "",

      });
      setSaveData({
        ...personal_info_form,
        ["jobOffice"]: "",
        ["jobPlace"]: "",
      });
      setValue("jobDesignation", "");
      setValue("jobOffice", "");
      setValue("jobPlace", "");
    }

    else if (evt.target.name === "isDomicile") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["categoryLookupId"]: "",
        ["verifyCategoryLookupId"]: "",
        ["castenameLookupId"]: "",
        ["casteCertificateNo"]: "",
        ["ccIssuingDate"]: "",
        ["isCcIssuedByBihar"]: null,
        ["ffcNumber"]: "",

        ["domicileCertificateNo"]: "",
        // ["categoryLookupId"]: "",

      });
      setDatePiker({
        ...datePickerData,
        ccIssuingDate: "",
        ffcIssuingDate: "",
        domicileIssuingDate: "",

      });
      setSaveData({
        ...personal_info_form,
        ["casteCertificateNo"]: "",
        ["ffcNumber"]: "",
        ["domicileCertificateNo"]: "",
      });

      setValue("categoryLookupId", "");
      setValue("verifyCategoryLookupId", "");
      setValue("castenameLookupId", "");
      setValue("casteCertificateNo", "");
      setValue("ccIssuingDate", "");
      setValue("isCcIssuedByBihar", null);
      setValue("ffcNumber", "");
      setValue("ffcIssuingDate", "");
      setValue("domicileCertificateNo", "");
      setValue("domicileIssuingDate", "");
    }
    else {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
      });
    }
    setReloadItem(!reloadItem);
  };
  const handleMaritialStatus = (evt) => {
    const value = evt.target.value;
    if (evt.target.name === "maritalStatusLookupId") {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["flgCandidateLiable"]: "",
        ["verifymaritalStatusLookupId"]: "",
      });
    } else {
      setPersonalDetail({
        ...personalDetails,
        [evt.target.name]: value,
        ["flgCandidateLiable"]: "",
      });
    }

    setSaveData({
      ...personal_info_form,
      ["husbandName"]: "",
    });
    setValue("husbandName", "");
    setValue("verifiedHusbandName", "");
    setValue("flgCandidateLiable", "");
    setReloadItem(!reloadItem);
  };

  const handleIdTypeChange = (evt) => {
    const value = evt.target.value;
    setAdharLookUp(value)
    setPersonalDetail({
      ...personalDetails,
      ["idTypeLookupId"]: value,
      ["adharLookUp"]: value,
      ["idNumber"]: personalDetails.idNumber,
    });
    setValue("idNumber", personalDetails.idNumber);
    setReloadItem(!reloadItem);
  };


  useEffect(() => {
    if (personalDetails) {
      if (
        allLookUpList &&
        allLookUpList.lookupOptionDtoList &&
        allLookUpList.lookupOptionDtoList.length > 0 &&
        allLookUpList.lookupOptionDtoList.filter(
          (ele) => ele.type === "id_type"
        )
      ) {
        const matchedItem = allLookUpList.lookupOptionDtoList
          .filter((ele) => ele.type === "id_type")
          .find((item) => item.id == personalDetails.idTypeLookupId);
        if (matchedItem && matchedItem) {
          setIdTypeLabel(matchedItem.label);
        } else {
          setIdTypeLabel("");
        }
      }
    } else if (
      allLookUpList &&
      allLookUpList.lookupOptionDtoList &&
      allLookUpList.lookupOptionDtoList.length > 0 &&
      allLookUpList.lookupOptionDtoList.filter((ele) => ele.type === "id_type")
    ) {
      const matchedItem = allLookUpList.lookupOptionDtoList
        .filter((ele) => ele.type === "id_type")
        .find((item) => item.id == idTypeLookupId);
      if (matchedItem && matchedItem) {
        setIdTypeLabel(matchedItem.label);
      } else {
        setIdTypeLabel("");
      }
    }

    if (personalDetails) {
      if (allLookUpList &&
        allLookUpList.lookupOptionDtoList &&
        allLookUpList.lookupOptionDtoList
          .filter((ele) => ele.type === "caste_category")) {
        const matchedItem = allLookUpList.lookupOptionDtoList
          .filter((ele) => ele.type === "caste_category")
          .find((item) => item.id == personalDetails.verifyCategoryLookupId);
        if (matchedItem && matchedItem) {
          setCategoryCodeLabel(matchedItem.label);
        } else {
          setCategoryCodeLabel("");
        }
      }

      if (allLookUpList &&
        allLookUpList.lookupOptionDtoList &&
        allLookUpList.lookupOptionDtoList
          .filter((ele) => ele.type === "designation")) {
        const matchedItem = allLookUpList.lookupOptionDtoList
          .filter((ele) => ele.type === "designation")
          .find((item) => item.id == personalDetails.jobDesignation);
        if (matchedItem && matchedItem) {
          setJobNatureLabel(matchedItem.label);
        } else {
          setJobNatureLabel("");
        }
      }
    }
  }, [idTypeLookupId, allLookUpList, personalDetails]);

  useEffect(() => {
    if (
      allLookUpList &&
      allLookUpList.lookupOptionDtoList &&
      allLookUpList.lookupOptionDtoList.filter((ele) => ele.type === "caste_name")
    ) {
      const matchedItem = allLookUpList.lookupOptionDtoList.filter(
        (item) => item.parentId == personalDetails.verifyCategoryLookupId
      );
      if (matchedItem && matchedItem.length > 0 && personalDetails.verifyCategoryLookupId !== '') {
        setCasteNameDropdownValue(matchedItem);
      } else {
        setCasteNameDropdownValue([]);
      }
    }
  }, [allLookUpList, personalDetails]);

  const handleGenderChange = (evt) => {
    handlePersonalDetailsDropdown(evt);
    setValue("flgTransgenderFemale", "No");
    setFlgTransgenderFemale("No");
    setReloadItem(!reloadItem);
  };

  let [flgMaharashtraKarnatakBorderArea, setFlgMaharashtraKarnatakBorderArea] =
    useState("No");
  let [borderTalukaOptions, setBorderTalukaOptions] = useState([]);
  let [borderVillageOptions, setBorderVillageOptions] = useState([]);

  let [borderAreaDetails, setBorderAreaDetails] = useState({
    borderDistrictLookupId: "",
    borderTalukaLookupId: "",
    borderVillageLookupId: "",
  });
  const checkValidity = (evt, value) => {
    if (evt.target.name === "verifiedHusbandName") {
      if (evt.target.value === watch("husbandName")) {
        setVerifyHusbandNameFlag(false);
      } else {
        setVerifyHusbandNameFlag(true);
      }
    }

    if (evt.target.name === "verifymaritalStatusLookupId") {
      if (evt.target.value === watch("maritalStatusLookupId")) {
        setVerifyMaritalStatusFlag(false);
      } else {
        setVerifyMaritalStatusFlag(true);
      }
    }

    if (evt.target.name === "verifyCategoryLookupId") {
      if (evt.target.value === watch("categoryLookupId")) {
        setVerifyCategoryCodeFlag(false);
      } else {
        setVerifyCategoryCodeFlag(true);
      }
    }

    if (evt.target.name === "verifiedNatureOfDivyang") {
      if (evt.target.value === watch("typeOfDisabilityLookupId")) {
        setVerifyDisabilityFlag(false);
      } else {
        setVerifyDisabilityFlag(true);
      }
    }
  };
  const dateDischargeArmedRegularVal = watch('dateDischargeArmedRegular');
  const exServiceManToDateVal = watch('exServiceManToDate');
  let exServicemanDateDifference = dateDifferece(dateDischargeArmedRegularVal, exServiceManToDateVal);

  const ncccIssuingDateVal = watch('ncccIssuingDate');
  const nccToDateVal = watch('nccToDate');
  let nccDateDifference = dateDifferece(ncccIssuingDateVal, nccToDateVal);

  const popupName = () => {
    setShowName(true);
  }
  const hideModal = () => {
    setShowName(false);
  }
  const takePhoto = () => {
    setShowName(false);
  };



  useEffect(() => {
    if (!props.profileStatus) {
      dispatch(disableAllSaveAfterSubmit(false));
    } else if (
      props.enableEditProfileWithLock?.editProfileWithLock == "1"
    ) {
      dispatch(disableAllSaveAfterSubmit(false));
    } else {
      dispatch(disableAllSaveAfterSubmit(true));
    }
  }, [dispatch, props.profileStatus, props.enableEditProfileWithLock?.editProfileWithLock]);




  const casteOptions = casteNameDropdownValue?.map((ele) => ({
    value: ele.id,
    label: ele.label,
  })) || [];

  const formattedUpdatedDate = new Date(profileFormDetailsData?.updatedAt)?.toLocaleDateString("en-GB");
  // "en-GB" ensures DD/MM/YYYY format



  const options =
    allLookUpList?.lookupOptionDtoList
      ?.filter((item) => item.type === 'designation')
      .map((item) => ({
        value: item.id,
        label: item.label,
      })) || [];

  const selectedOption = options.find(
    (opt) => opt.value === personalDetails.jobDesignation
  );

  return arraymModule && arraymModule.isEnabled == false ? (
    <ModuleHide details={arraymModule} />
  ) : (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="p-4 f12">
        <div className="p-1 bg-blue date_flex">
          <h5 className="text-white">
            <img src="/icons/user-detail.png" /> &nbsp;
            {commonENLabels.PERSONAL_INFORMATION.PERSONAL_INFORMATION}{" "}
            {commonHILabels.PERSONAL_INFORMATION.PERSONAL_INFORMATION}
          </h5>
          <h5 className="text-white last_updated_date">
            {commonENLabels.LAST_UPDATED_ON}{" "}
            {getFormattedLastUpdatedDate(formattedUpdatedDate)}
          </h5>
        </div>

        <h5 className="bottom-dotted-line m-0 mt-3">
          {numberformat["1"]}.&nbsp;{profile.SECOUND_PROFILE_HEADER} :{" "}
          {commonHILabels.PERSONAL_INFORMATION.PERSONAL_DETAILS}
        </h5>
        <div className="row">
          <div className="form-group col-md-4">
            <div>
              <label className="LeftText f11 font-weight">
                {numberformat["1.1"]}&nbsp;
                {commonENLabels.PERSONAL_INFORMATION.CANDIDATE_NAME}
              </label>
              <label className="f11 margin-top-10">
                {commonHILabels.PERSONAL_INFORMATION.CANDIDATE_NAME}
              </label>
              <span className="errorText">*</span>{" "}
              {personalInfoDigilockerStatuses &&
                personalInfoDigilockerStatuses.name == true ? (
                <span className="digilockerText">
                  &nbsp;&nbsp;
                  <img src="/icons/tickIcon.png" width="20" height="20" />{" "}
                  Digilocker verified
                </span>
              ) : (
                ""
              )}
            </div>
            <div className="input-group bg-color">
              <input
                type="text"
                className="form-control special-disabled text-uppercase"
                maxLength={shortNameMaxLength}
                defaultValue={
                  personal_info_form && personal_info_form.englishFullName
                }
                name="englishFullName"
                disabled
                ref={register({
                  required: true,
                  pattern: {
                    value: /^(?!\s+$)[A-Za-zăâîșțĂÂÎȘȚ\s_.]+$/,
                  },
                })}
              />
            </div>
            {_.get("englishFullName.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
            {/* {_.get("englishFullName.type", errors) === "pattern" && (
              <p className="errorText">{profile.ENTER_VALID_SURNAME}</p>
            )} */}
          </div>
          <div className="form-group col-md-4">
            <label className="LeftText f11 font-weight">
              {numberformat["1.2"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.HINDI_NAME}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.HINDI_NAME}
            </label>
            <span className="errorText">*</span>
            {personal_info_form && personal_info_form.devnagariFullName ? (
              <div>
                <Controller
                  name="devnagariFullName"
                  control={control}
                  key="devnagariFullName"
                  defaultValue={personal_info_form.devnagariFullName}
                  rules={{ required: true }}
                  render={({ onChange, value }) => (
                    <Devnagari onChange={onChange} value={value} allowPaste="true"/>
                  )}
                />
              </div>
            ) : (
              <div>
                <Controller
                  name="devnagariFullName"
                  control={control}
                  key="devnagari1"
                  defaultValue=""
                  rules={{ required: true }}
                  render={({ onChange, value }) => (
                    <Devnagari onChange={onChange} value={value}  allowPaste="true" />
                  )}
                />
              </div>
            )}
            {_.get("devnagariFullName.type", errors) === "required" && (
              <p className="errorText ms-3">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
          </div>
          <div className="form-group col-md-4">
            <label className="LeftText f11 font-weight">
              {numberformat["1.3"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.DATE_OF_BIRTH}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.DATE_OF_BIRTH}
            </label>
            <span className="errorText">*</span>
            {personalInfoDigilockerStatuses &&
              personalInfoDigilockerStatuses.dob == true ? (
              <span className="digilockerText">
                &nbsp;&nbsp;
                <img src="/icons/tickIcon.png" width="20" height="20" />{" "}
                Digilocker verified
              </span>
            ) : (
              ""
            )}
            <div className="input-group bg-color">
              <Controller
                name="dob"
                control={control}
                key="dateOfBirthKey1"
                defaultValue={datePickerData.dob}
                rules={{ required: false }}
                render={({ onChange, value }) => (
                  <div className="date-picker-container">
                    <DatePicker
                      // showIcon
                      selected={authenticatedUserData?.dob}
                      onChange={(e) => {
                        onChange(toUTCDate(e));
                      }}
                      onKeyDown={preventDateManualTyping}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      disabled={true}
                      placeholderText={commonLabels.DATE_FORMAT}
                      className="form-control bg-color ps-2 special-disabled"
                      maxDate={new Date()}
                      dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                      icon={
                        <img
                          src="/icons/calender.png"
                          className="date-picker-icon"
                        ></img>
                      }
                    />
                  </div>
                )}
              />
            </div>
          </div>
          <div className="form-group col-md-4">
            <label className="LeftText f11 font-weight">
              {numberformat["1.4"]}&nbsp;{commonENLabels.SIGN_UP.GENDER}
              <span className="errorText">*</span>{" "}
              {personalInfoDigilockerStatuses &&
                personalInfoDigilockerStatuses.gender == true ? (
                <span className="digilockerText">
                  &nbsp;&nbsp;
                  <img src="/icons/tickIcon.png" width="20" height="20" />{" "}
                  Digilocker verified
                </span>
              ) : (
                ""
              )}
            </label>
            <div className="input-group">
              <select
                className="form-select bg-color special-disabled bg-image-none"
                name="gender"
                ref={register({ required: true })}
                value={personalDetails.gender}
                disabled
                onInput={handleGenderChange}
              >
                <option key={0} value="">
                  {advertisementDetailsLabel.SELECT}
                </option>
                {allLookUpList &&
                  allLookUpList.lookupOptionDtoList &&
                  allLookUpList.lookupOptionDtoList
                    .filter((ele) => ele.type === "gender")
                    .map((ele, ind) => {
                      return (
                        <option key={ind} value={ele.id}>
                          {ele.label}
                        </option>
                      );
                    })}
              </select>
            </div>
            {_.get("gender.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
          </div>
          <div className="form-group col-md-4">
            <label className="LeftText f11 font-weight">
              {numberformat["1.5"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.FATHER_NAME}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.FATHER_NAME}
            </label>
            <span className="errorText">*</span>
            {personalInfoDigilockerStatuses &&
              personalInfoDigilockerStatuses.father_name == true ? (
              <span className="digilockerText">
                &nbsp;&nbsp;
                <img src="/icons/tickIcon.png" width="20" height="20" />{" "}
                Digilocker verified
              </span>
            ) : (
              ""
            )}
            <div className="input-group bg-color">
              <input
                type="text"
                className="form-control special-disabled text-uppercase"
                maxLength={shortNameMaxLength}
                defaultValue={
                  personal_info_form && personal_info_form.fatherName
                }
                name="fatherName"
                disabled
                ref={register({
                  required: true,
                  pattern: fullname,
                  maxLength: 100,
                })}
              />
            </div>
            {_.get("fatherName.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
            {_.get("fatherName.type", errors) === "pattern" && (
              <p className="errorText">{profile.ENTER_VALID_FATHER_NAME}</p>
            )}
            {/* {_.get("fatherName.type", errors) === "maxLength" && (
              <p className="errorText">{profile.MAX_VALUE_FOR_30_CHAR}</p>
            )} */}

          </div>
          <div className="form-group col-md-4">
            <label className="LeftText f11 font-weight">
              {numberformat["1.6"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.MOTHER_NAME}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.MOTHER_NAME}
            </label>
            <span className="errorText">*</span>
            {personalInfoDigilockerStatuses &&
              personalInfoDigilockerStatuses.mother_name == true ? (
              <span className="digilockerText">
                &nbsp;&nbsp;
                <img src="/icons/tickIcon.png" width="20" height="20" />{" "}
                Digilocker verified
              </span>
            ) : (
              ""
            )}
            <div className="input-group bg-color">
              <input
                type="text"
                className="form-control special-disabled text-uppercase"
                maxLength={shortNameMaxLength}
                defaultValue={
                  personal_info_form && personal_info_form.motherName
                }
                name="motherName"
                disabled
                ref={register({
                  required: true,
                  pattern: fullname,
                  maxLength: 100,
                })}
              />
            </div>
            {_.get("motherName.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
            {_.get("motherName.type", errors) === "pattern" && (
              <p className="errorText">{profile.ENTER_VALID_MOTHER_NAME}</p>
            )}
            {/* {_.get("motherName.type", errors) === "maxLength" && (
              <p className="errorText">{profile.MAX_VALUE_FOR_30_CHAR}</p>
            )} */}
          </div>

          <div className="col-md-4">
            <label className="LeftText f11 font-weight">
              {numberformat["1.7"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.MARITAL_STATUS}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.MARITAL_STATUS}
            </label>
            <span className="errorText">*</span>
            <div className="input-group">
              <select
                className="form-select bg-color"
                name="maritalStatusLookupId"
                ref={register({ required: true })}
                value={personalDetails.maritalStatusLookupId}
                onInput={handleMaritialStatus}
              >
                <option key={0} value="">
                  {advertisementDetailsLabel.SELECT}
                </option>
                {allLookUpList &&
                  allLookUpList.lookupOptionDtoList &&
                  allLookUpList.lookupOptionDtoList
                    .filter((ele) => ele.type === "marital_status")
                    .map((ele, ind) => {
                      return (
                        <option key={ind} value={ele.id}>
                          {ele.label}
                        </option>
                      );
                    })}
              </select>
            </div>
            {_.get("maritalStatusLookupId.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
          </div>
          <div className="col-md-4">
            <label className="LeftText f11 font-weight">
              {numberformat["1.8"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.VERIFY_MARITAL_STATUS}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.VERIFY_MARITAL_STATUS}
            </label>
            <span className="errorText">*</span>
            <div className="input-group">
              <select
                className="form-select bg-color"
                name="verifymaritalStatusLookupId"
                ref={register({ required: true })}
                value={personalDetails.verifymaritalStatusLookupId}
                onInput={(e) => {
                  handleMaritialStatus(e);
                  checkValidity(e);
                }}
              >
                <option key={0} value="">
                  {advertisementDetailsLabel.SELECT}
                </option>
                {allLookUpList &&
                  allLookUpList.lookupOptionDtoList &&
                  allLookUpList.lookupOptionDtoList
                    .filter((ele) => ele.type === "marital_status")
                    .map((ele, ind) => {
                      return (
                        <option key={ind} value={ele.id}>
                          {ele.label}
                        </option>
                      );
                    })}
              </select>
            </div>
            {_.get("verifymaritalStatusLookupId.type", errors) ===
              "required" && (
                <p className="errorText">
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
            {verifyMaritalStatusFlag &&
              _.get("verifymaritalStatusLookupId.type", errors) != "required" ? (
              <p className="errorText">
                {
                  commonENLabels.PERSONAL_INFORMATION
                    .MARITAL_STATUS_AND_VERIFY_MARITAL_STATUS
                }
              </p>
            ) : (
              ""
            )}
          </div>

          {genderLabel === "Female" && maritalStatusLabel === "Married" && (
            <div className="form-group col-md-4">
              <div>
                <label className="LeftText f11 font-weight">
                  {numberformat["1.8.3"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.HUSBAND_NAME}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.HUSBAND_NAME}
                </label>
                <span className="errorText">*</span>
              </div>
              <div className="input-group bg-color">
                <input
                  className="form-control text-uppercase"
                  id="registrationFormControlInput1"
                  type="text"
                  ref={register({ required: true, pattern: fullname })}
                  name="husbandName"
                  placeholder={commonENLabels.PERSONAL_INFORMATION.HUSBAND_NAME}
                  defaultValue={
                    personal_info_form && personal_info_form.husbandName
                  }
                  onChange={(e) => {
                    setValue("verifiedHusbandName", "");
                  }}
                />
              </div>
              {_.get("husbandName.type", errors) === "required" && (
                <p className="errorText">
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
              {_.get("husbandName.type", errors) === "pattern" && (
                <p className="errorText">
                  {commonENLabels.VALIDATE_MESSAGE.ENTER_VALID_NAME}
                </p>
              )}
            </div>
          )}
          {genderLabel === "Female" && maritalStatusLabel === "Married" && (
            <div className="form-group col-md-4">
              <div>
                <label className="LeftText f11 font-weight">
                  {numberformat["1.8.4"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.VERIFY_HUSBAND_NAME}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.VERIFY_HUSBAND_NAME}
                </label>
                <span className="errorText">*</span>
              </div>
              <div className="input-group bg-color">
                <input
                  className="form-control text-uppercase"
                  id="registrationFormControlInput1"
                  type="text"
                  ref={register({ required: true, pattern: fullname })}
                  name="verifiedHusbandName"
                  placeholder={
                    commonENLabels.PERSONAL_INFORMATION.VERIFY_HUSBAND_NAME
                  }
                  onInput={checkValidity}
                  defaultValue={
                    personal_info_form && personal_info_form.husbandName
                  }
                />
              </div>
              {_.get("verifiedHusbandName.type", errors) === "required" && (
                <p className="errorText">
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
              {verifyHusbandNameFlag &&
                _.get("verifiedHusbandName.type", errors) != "required" ? (
                <p className="errorText">
                  {
                    commonENLabels.PERSONAL_INFORMATION
                      .HUSBAND_NAME_AND_VERIFY_HUSBAND_NAME
                  }
                </p>
              ) : (
                ""
              )}
            </div>
          )}

          {profileFormDetailsData.idTypeLookupId == "517" ?
            <div className="col-md-4">
              <label className="LeftText f11 font-weight">
                {numberformat["1.9"]}&nbsp;
                {commonENLabels.PERSONAL_INFORMATION.ID_TYPE}
              </label>
              <label className="f11 margin-top-10">
                {commonHILabels.PERSONAL_INFORMATION.ID_TYPE}
              </label>
              <span className="errorText">*</span>
              <div className="input-group">
                <select
                  // className={personalInfoDigilockerStatuses && personalInfoDigilockerStatuses.id_number == true ? "form-select bg-color  special-disabled" : "form-select bg-color"}
                  className="form-select bg-color special-disabled bg-image-none"
                  // className="form-select bg-color"
                  name="adharLookUp"
                  ref={register({ required: true })}
                  value={personalDetails.idTypeLookupId}
                  onInput={handleIdTypeChange}
                  disabled
                // disabled={personalInfoDigilockerStatuses && personalInfoDigilockerStatuses.id_number == true ? true : false}
                >
                  <option key={0} value="">
                    {advertisementDetailsLabel.SELECT}
                  </option>
                  {allLookUpList &&
                    allLookUpList.lookupOptionDtoList &&
                    allLookUpList.lookupOptionDtoList
                      .filter((ele) => ele.type === "id_type")
                      .map((ele, ind) => {
                        return (
                          <option key={ind} value={ele.id}>
                            {ele.label}
                          </option>
                        );
                      })}
                </select>
              </div>
              {_.get("idTypeLookupId.type", errors) === "required" && (
                <p className="errorText">
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
            </div>
            :
            <div className="col-md-4">
              <label className="LeftText f11 font-weight">
                {numberformat["1.9"]}&nbsp;
                {commonENLabels.PERSONAL_INFORMATION.ID_TYPE}
              </label>
              <label className="f11 margin-top-10">
                {commonHILabels.PERSONAL_INFORMATION.ID_TYPE}
              </label>
              <span className="errorText">*</span>
              <div className="input-group">
                <select
                  // className={personalInfoDigilockerStatuses && personalInfoDigilockerStatuses.id_number == true ? "form-select bg-color  special-disabled" : "form-select bg-color"}
                  className="form-select bg-color special-disabled "
                  name="idTypeLookupId"
                  ref={register({ required: true })}
                  value={personalDetails.idTypeLookupId}
                  onInput={handleIdTypeChange}
                // disabled={personalInfoDigilockerStatuses && personalInfoDigilockerStatuses.id_number == true ? true : false}
                >
                  <option key={0} value="">
                    {advertisementDetailsLabel.SELECT}
                  </option>
                  {allLookUpList &&
                    allLookUpList.lookupOptionDtoList &&
                    allLookUpList.lookupOptionDtoList
                      .filter((ele) => ele.type === "id_type")
                      .map((ele, ind) => {
                        return (
                          <option key={ind} value={ele.id}>
                            {ele.label}
                          </option>
                        );
                      })}
                </select>
              </div>
              {_.get("idTypeLookupId.type", errors) === "required" && (
                <p className="errorText">
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
            </div>
          }
          {(profileFormDetailsData.idTypeLookupId == "517" && personalDetails.idTypeLookupId == "517") ? (
            <div className="form-group col-md-4">
              <label className="LeftText f11 font-weight">
                {numberformat["1.10"]}&nbsp;{commonENLabels.SIGN_UP.AADHAR_NO}
                <span className="errorText">*</span>{" "}
                {personalInfoDigilockerStatuses?.Id_Number === true && (
                  <span className="digilockerText">
                    &nbsp;&nbsp;
                    <img src="/icons/tickIcon.png" width="20" height="20" alt="verified" />{" "}
                    Digilocker verified
                  </span>
                )}
              </label>
              <div className="input-group bg-color">
                <input
                  className="form-control special-disabled text-uppercase"
                  id="registrationFormControlInput1"
                  type="text"
                  name="idNumber"
                  placeholder={commonENLabels.SIGN_UP.AADHAR_NO_PLACEHOLDER}
                  minLength="12"
                  maxLength="12"
                  defaultValue={personalDetails?.idNumber}
                  disabled
                  autoComplete="off"
                />
              </div>
            </div>
          ) : profileFormDetailsData.idTypeLookupId == "517" ? (
            <div className="form-group col-md-4">
              <label className="LeftText f11 font-weight">
                {numberformat["1.10"]}&nbsp;{commonENLabels.SIGN_UP.AADHAR_NO}
                <span className="errorText">*</span>{" "}
                {personalInfoDigilockerStatuses?.Id_Number === true && (
                  <span className="digilockerText">
                    &nbsp;&nbsp;
                    <img src="/icons/tickIcon.png" width="20" height="20" alt="verified" />{" "}
                    Digilocker verified
                  </span>
                )}
              </label>
              <div className="input-group bg-color">
                <input
                  className="form-control special-disabled text-uppercase"
                  id="registrationFormControlInput1"
                  type="text"
                  name="idNumber"
                  placeholder={commonENLabels.SIGN_UP.AADHAR_NO_PLACEHOLDER}
                  minLength="12"
                  maxLength="12"
                  defaultValue={personalDetails?.idNumber}
                  disabled
                  autoComplete="off"
                />
              </div>
            </div>
          ) : personalDetails.idTypeLookupId == "517" && (
            <div className="form-group col-md-4">
              <label className="LeftText f11 font-weight">
                {numberformat["1.10"]}&nbsp;{commonENLabels.SIGN_UP.AADHAR_NO}
                <span className="errorText">*</span>{" "}
                {personalInfoDigilockerStatuses?.Id_Number === true && (
                  <span className="digilockerText">
                    &nbsp;&nbsp;
                    <img src="/icons/tickIcon.png" width="20" height="20" alt="verified" />{" "}
                    Digilocker verified
                  </span>
                )}
              </label>
              <div className="input-group bg-color">
                <input
                  className="form-control text-uppercase"
                  id="registrationFormControlInput1"
                  type="text"
                  ref={register({ required: true, pattern: aadhaarNumber })}
                  name="idNumber"
                  placeholder={commonENLabels.SIGN_UP.AADHAR_NO_PLACEHOLDER}
                  minLength="12"
                  maxLength="12"
                  onChange={(e) => handlePersonalDetailsDropdown(e)}
                  defaultValue={personalDetails?.idNumber}
                  autoComplete="off"
                />
              </div>
            </div>
          )}


          {idTypeLabel === commonENLabels.COMMON.PAN_CARD && (
            <div className="form-group col-md-4">
              <label className="LeftText f11 font-weight">
                {numberformat["1.10"]}&nbsp;{commonENLabels.SIGN_UP.PAN_CARD_NO}
                <span className="errorText">*</span>
                {personalInfoDigilockerStatuses &&
                  personalInfoDigilockerStatuses.Id_Number == true ? (
                  <span className="digilockerText">
                    &nbsp;&nbsp;
                    <img
                      src="/icons/tickIcon.png"
                      width="20"
                      height="20"
                    />{" "}
                    Digilocker verified
                  </span>
                ) : (
                  ""
                )}
              </label>
              <div className="input-group bg-color">
                <input
                  className="form-control  text-uppercase"
                  // className={personalInfoDigilockerStatuses && personalInfoDigilockerStatuses.id_number == true ? "form-control  special-disabled" : "form-control"}
                  id="registrationFormControlInput1"
                  type="text"
                  ref={register({ required: true, pattern: panCardRegex })}
                  name="idNumber"
                  placeholder={commonENLabels.SIGN_UP.PAN_CARD_NO_PLACEHOLDER}
                  minLength="10"
                  maxLength="10"
                  onChange={(e) => {
                    handlePersonalDetailsDropdown(e);
                  }}
                  // ref={register({ required: true })}
                  defaultValue={personalDetails && personalDetails.idNumber ? (personalDetails.idNumber).toUpperCase() : ''}
                  // disabled={personalInfoDigilockerStatuses && personalInfoDigilockerStatuses.id_number == true ? true : false}
                  autoComplete="off"
                // disabled
                />
              </div>
              {_.get("idNumber.type", errors) === "required" && (
                <p className="errorText">
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
              {_.get("idNumber.type", errors) === "pattern" && (
                <p className="errorText">
                  {commonENLabels.VALIDATE_MESSAGE.ENTER_VALID_PAN_NUMBER}
                </p>
              )}
            </div>
          )}

          {idTypeLabel === commonENLabels.COMMON.DRIVING_LICENCE && (
            <div className="form-group col-md-4">
              <label className="LeftText f11 font-weight">
                {numberformat["1.10"]}&nbsp;
                {commonENLabels.SIGN_UP.DRIVING_LI_NO}
                <span className="errorText">*</span>{" "}
                {personalInfoDigilockerStatuses &&
                  personalInfoDigilockerStatuses.Id_Number == true ? (
                  <span className="digilockerText">
                    &nbsp;&nbsp;
                    <img
                      src="/icons/tickIcon.png"
                      width="20"
                      height="20"
                    />{" "}
                    Digilocker verified
                  </span>
                ) : (
                  ""
                )}{" "}
              </label>



              <div className="input-group bg-color">
                <input
                  className="form-control special-disabled text-uppercase"
                  // className={personalInfoDigilockerStatuses && personalInfoDigilockerStatuses.id_number == true ? "form-control  special-disabled" : "form-control"}
                  id="registrationFormControlInput1"
                  type="text"
                  ref={register({
                    required: true,
                    pattern: drivingLicenseRegex,
                  })}
                  // 
                  name="idNumber"
                  placeholder={commonENLabels.SIGN_UP.DRIVING_LI_NO_PLACEHOLDER}
                  minLength="15"
                  maxLength="15"
                  onChange={(e) => {
                    handlePersonalDetailsDropdown(e);
                  }}
                  defaultValue={personalDetails && personalDetails.idNumber ? (personalDetails.idNumber).toUpperCase() : ''}
                  // disabled={personalInfoDigilockerStatuses && personalInfoDigilockerStatuses.id_number == true ? true : false}
                  autoComplete="off"
                // disabled
                />
              </div>

              {_.get("idNumber.type", errors) === "required" && (
                <p className="errorText">
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
              {_.get("idNumber.type", errors) === "pattern" && (
                <p className="errorText">
                  {
                    commonENLabels.VALIDATE_MESSAGE
                      .ENTER_VALID_DRIVING_LICENCE_NUMBER
                  }
                </p>
              )}
            </div>
          )}

          <div className="form-group col-md-4">
            <label className="LeftText f11 font-weight">
              {numberformat["1.11"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.IDENTIFICATION_MARK}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.IDENTIFICATION_MARK}
            </label>
            <span className="errorText">*</span>
            <div className="input-group bg-color">
              <input
                className="form-control text-uppercase"
                id="registrationFormControlInput1"
                type="text"
                ref={register({ required: true, pattern: alphabets })}
                name="identificationMark"
                defaultValue={
                  personal_info_form && personal_info_form.identificationMark
                }
                autoComplete="off"
              />
            </div>
            {_.get("identificationMark.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
            {_.get("identificationMark.type", errors) === "pattern" && (
              <p className="errorText">
                {
                  commonENLabels.VALIDATE_MESSAGE
                    .ONLY_ALPHABETS_ALLOWED
                }
              </p>
            )}
          </div>

          <div className="col-md-4 d-flex flex-row gap-1">
            <div className="col-md-12 ">
              <label className="LeftText f11 font-weight">
                {numberformat["1.11.1"]}&nbsp;
                {commonENLabels.PERSONAL_INFORMATION.HAVE_YOU_CHANGED_NAME}  {commonHILabels.PERSONAL_INFORMATION.HAVE_YOU_CHANGED_NAME}     <span className="errorText">*</span>
              </label>
              &nbsp;
              <label className="form-check-label position-relative float-start mt-2">
                <input
                  type="radio"
                  className="RadioText"
                  checked={
                    personalDetails && personalDetails.isNameChanged === "No" ? true : false
                  }
                  onChange={(e) => {
                    handlePersonalDetailsDropdown(e);
                  }}
                  value="No"
                  name="isNameChanged"
                  ref={register({ required: true })}
                />
                &nbsp;{profile.NO}
              </label>
              <label className="form-check-label position-relative float-center mt-2 ">
                <input
                  type="radio"
                  checked={
                    personalDetails && personalDetails.isNameChanged === "Yes" ? true : false
                  }
                  onChange={(e) => {
                    handlePersonalDetailsDropdown(e);
                  }}
                  className="RadioText"
                  value="Yes"
                  name="isNameChanged"
                  ref={register({ required: true })}
                />
                &nbsp;{profile.YES}
              </label>
            </div>
          </div>
          {(showChangedName || personalDetails.isNameChanged === "Yes") && <div className="col-md-4">
            <label className="LeftText f11 font-weight">
              {numberformat["1.11.2"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.CHANGED_NAME}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.CHANGED_NAME}
              <span className="errorText">*</span>
            </label>
            <div className="input-group  bg-color">
              <input
                className="form-control text-uppercase"
                id="changedEnglishName"
                type="text"
                ref={register({ required: true, pattern: alphabets })}
                name="changedEnglishName"
                defaultValue={
                  personal_info_form && personal_info_form.changedEnglishName
                }
                autoComplete="off"
              />
            </div>
            {_.get("changedEnglishName.type", errors) === "pattern" && (
              <p className="errorText">
                {
                  commonENLabels.VALIDATE_MESSAGE
                    .ONLY_ALPHABETS_ALLOWED
                }
              </p>
            )}
            {_.get("changedEnglishName.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
          </div>
          }









          {/* Chnaged Name */}


































          <div className="col-md-12">
            <label className="LeftText f11 font-weight">
              {numberformat["1.12"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.ARE_YOU_CITIZEN_OF_INDIA}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.ARE_YOU_CITIZEN_OF_INDIA}
            </label>
            <span className="errorText">*</span>
            &nbsp;
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                className="RadioText"
                checked={
                  personalDetails.nationalityLookupId === "No" ? true : false
                }
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                value="No"
                name="nationalityLookupId"
                ref={register({ required: true })}
              />
              &nbsp;{profile.NO}
            </label>
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                checked={
                  personalDetails.nationalityLookupId === "Yes" ? true : false
                }
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                className="RadioText"
                value="Yes"
                name="nationalityLookupId"
                ref={register({ required: true })}
              />
              &nbsp;{profile.YES}
            </label>
             {_.get("nationalityLookupId.type", errors) === "required" && (
                  <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                   </p>
                 )}
          </div>

          {citizenshipMessage && <Modal show={showName} onHide={hideModal} size="s" backdrop="static" centered>
            <Modal.Header className="custom-modal-header logout_heading">
              <Modal.Title className="logout_title">
               {commonENLabels.CITIZENSIP_WARNING_TITLE} 
              </Modal.Title>

              <button
                type="button"
                className="ms-auto logout_close"
                aria-label="Close"
                onClick={hideModal}
              >X</button>
            </Modal.Header>
            <Modal.Body className="d-flex flex-column align-items-center">
                {commonENLabels.CITIZENSIP_WARNING_LINE_2}
                <hr />
                {commonHILabels.CITIZENSIP_WARNING_LINE_2} 

             
            </Modal.Body>
             <Modal.Footer>
                                <button type="button" className="btn btn-primary" onClick={takePhoto}>{commonLabels.OK}</button>
                            </Modal.Footer>
          </Modal>}

          {personalDetails.nationalityLookupId === "Yes" && <div className="col-md-12">
            <label className="LeftText f11 font-weight">
              {numberformat["1.13"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.NOTE_1_15}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.NOTE_1_15}
            </label>
            <span className="errorText">*</span>
            &nbsp;
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                className="RadioText"
                checked={personalDetails.isDomicile === "No" ? true : false}
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                value="No"
                name="isDomicile"
                ref={register({ required: true })}
              />
              &nbsp;{profile.NO}
            </label>
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                checked={personalDetails.isDomicile === "Yes" ? true : false}
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                className="RadioText"
                value="Yes"
                name="isDomicile"
                ref={register({ required: true })}
              />
              &nbsp;{profile.YES}
            </label>
            {_.get("isDomicile.type", errors) === "required" && (
                 <p className="errorText">
                     {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                  </p>
                )}
          </div>
          }
          {personalDetails.nationalityLookupId === "Yes" &&
            <div className="col-md-12">
              <label className="LeftText f11 font-weight">
                {numberformat["1.14"]}&nbsp;
                {commonENLabels.PERSONAL_INFORMATION.NOTE_1_16}
              </label>
              <label className="f11 margin-top-10">
                {commonHILabels.PERSONAL_INFORMATION.NOTE_1_16}
              </label>
              <span className="errorText">*</span>
              &nbsp;
              <label className="form-check-label position-relative float-end mt-2">
                <input
                  type="radio"
                  className="RadioText"
                  checked={
                    personalDetails.isVerifiedDomicile === "No" ? true : false
                  }
                  onChange={(e) => {
                    handlePersonalDetailsDropdown(e);
                  }}
                  value="No"
                  name="isVerifiedDomicile"
                  ref={register({ required: true })}
                />
                &nbsp;{profile.NO}
              </label>
              <label className="form-check-label position-relative float-end mt-2">
                <input
                  type="radio"
                  checked={
                    personalDetails.isVerifiedDomicile === "Yes" ? true : false
                  }
                  onChange={(e) => {
                    handlePersonalDetailsDropdown(e);
                  }}
                  className="RadioText"
                  value="Yes"
                  name="isVerifiedDomicile"
                  ref={register({ required: true })}
                />
                &nbsp;{profile.YES}
              </label>
               {_.get("isVerifiedDomicile.type", errors) === "required" && (
                  <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                   </p>
                 )}
              {verifyPermenantResidentFlg && <p className="errorText">{commonENLabels.PERSONAL_INFORMATION.PERMANENT_RESIDENT_AND_PERMANENT_RESIDENT}</p>}
            </div>}


          {personalDetails.nationalityLookupId !== "Yes" || personalDetails.isDomicile !== "Yes" || personalDetails.isVerifiedDomicile === "Yes" && (
            <>
              <div className="col-md-12">
                <label className="LeftText f11 font-weight">
                  {numberformat["1.15"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_17}
                </label>
                {((personalDetails.isVerifiedDomicile === "Yes") && (((personalDetails.gender === commonENLabels.DATABASE_VALUES.MALE_GENDER_LOOKUP_ID) && (personalDetails.isReservedCategory === "Yes")) || (personalDetails.gender === commonENLabels.DATABASE_VALUES.FEMALE_GENDER_LOOKUP_ID))) && (
                  <span className="errorText">*</span>
                )}
                &nbsp;
              </div>
              <div className="form-group col-md-4">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.RESIDENCE_CERTIFICATE_NO}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.RESIDENCE_CERTIFICATE_NO}
                </label>
                {((personalDetails.isVerifiedDomicile === "Yes") && (((personalDetails.gender === commonENLabels.DATABASE_VALUES.MALE_GENDER_LOOKUP_ID) && (personalDetails.isReservedCategory === "Yes")) || (personalDetails.gender === commonENLabels.DATABASE_VALUES.FEMALE_GENDER_LOOKUP_ID))) && (
                  <span className="errorText">*</span>
                )}
                <div className="input-group bg-color">
                  <input
                    className="form-control text-uppercase"
                    id="registrationFormControlInput1"
                    type="text"
                    ref={register({
                      required:
                        ((personalDetails.isVerifiedDomicile === "Yes") && (((personalDetails.gender === commonENLabels.DATABASE_VALUES.MALE_GENDER_LOOKUP_ID) && (personalDetails.isReservedCategory === "Yes")) || (personalDetails.gender === commonENLabels.DATABASE_VALUES.FEMALE_GENDER_LOOKUP_ID)))
                          ? true
                          : false,
                      pattern: certificateNumbeForNclandDomicileRegex,
                    })}
                    name="domicileCertificateNo"
                    placeholder={
                      commonENLabels.PERSONAL_INFORMATION.RESIDENCE_CERTIFICATE_NO
                    }
                    defaultValue={
                      personal_info_form &&
                      personal_info_form.domicileCertificateNo
                    }
                    autoComplete="off"
                  />
                </div>
                {_.get("domicileCertificateNo.type", errors) === "required" && (
                  <p className="errorText">
                    {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                  </p>
                )}
                {_.get("domicileCertificateNo.type", errors) === "pattern" && (
                  <p className="errorText">
                    {
                      commonENLabels.VALIDATE_MESSAGE
                        .ENTER_VALID_CERTIFICATE_NUMBER
                    }
                  </p>
                )}
              </div>
              <div className="form-group col-md-4">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_2}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_2}
                </label>
                {((personalDetails.isVerifiedDomicile === "Yes") && (((personalDetails.gender === commonENLabels.DATABASE_VALUES.MALE_GENDER_LOOKUP_ID) && (personalDetails.isReservedCategory === "Yes")) || (personalDetails.gender === commonENLabels.DATABASE_VALUES.FEMALE_GENDER_LOOKUP_ID))) && (
                  <span className="errorText">*</span>
                )}
                <div>
                  <Controller
                    name="domicileIssuingDate"
                    control={control}
                    key={
                      personal_info_form && personal_info_form.id
                        ? "domicileIssuingDateKey1"
                        : "domicileIssuingDateKey2"
                    }
                    defaultValue={
                      personal_info_form && personal_info_form.id
                        ? datePickerData.domicileIssuingDate
                        : ""
                    }
                    rules={{
                      required:
                        ((personalDetails.isVerifiedDomicile === "Yes") && (((personalDetails.gender === commonENLabels.DATABASE_VALUES.MALE_GENDER_LOOKUP_ID) && (personalDetails.isReservedCategory === "Yes")) || (personalDetails.gender === commonENLabels.DATABASE_VALUES.FEMALE_GENDER_LOOKUP_ID)))
                          ? true
                          : false,
                    }}
                    render={({ onChange, value }) => (
                      <div>
                        <DatePicker
                          showIcon
                          selected={getFormattedDate(value)}
                          onChange={(e) => {
                            onChange(toUTCDate(e));
                          }}
                          // onKeyDown={preventDateManualTyping}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText={commonLabels.DATE_FORMAT}
                          className="form-control bg-color ps-2"
                          maxDate={new Date()}
                          minDate={getFormattedDate(authenticatedUserData?.dob)}
                          dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                          icon={
                            <img
                              src="/icons/calender.png"
                              className="date-picker-icon"
                            ></img>
                          }
                        />
                      </div>
                    )}
                  />
                  {_.get("domicileIssuingDate.type", errors) == "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        {(personalDetails.nationalityLookupId === "Yes" && personalDetails.isDomicile === "Yes") && <><hr></hr>
          <h5 className="bottom-dotted-line align-left p-1">
            &nbsp; {commonENLabels.PERSONAL_INFORMATION.CASTE_CATEGORY_DETAILS}{" "}
            {commonHILabels.PERSONAL_INFORMATION.CASTE_CATEGORY_DETAILS}
          </h5>
          <span></span>
          <div className="row">
            <div className="col-md-12">
              <label className="LeftText f11 font-weight">
                {numberformat["1.16"]}&nbsp;
                {commonENLabels.PERSONAL_INFORMATION.NOTE_1_18}
              </label>
              <label className="f11 margin-top-10">
                {commonHILabels.PERSONAL_INFORMATION.NOTE_1_18}
              </label>
              <span className="errorText">*</span>
              &nbsp;
              <label className="form-check-label position-relative float-end mt-2">
                <input
                  type="radio"
                  className="RadioText"
                  checked={
                    personalDetails.isReservedCategory === "No" ? true : false
                  }
                  onChange={(e) => {
                    handlePersonalDetailsDropdown(e);
                  }}
                  value="No"
                  name="isReservedCategory"
                  ref={register({ required: true })}
                />
                &nbsp;{profile.NO}
              </label>
              <label className="form-check-label position-relative float-end mt-2">
                <input
                  type="radio"
                  checked={
                    personalDetails.isReservedCategory === "Yes" ? true : false
                  }
                  onChange={(e) => {
                    handlePersonalDetailsDropdown(e);
                  }}
                  className="RadioText"
                  value="Yes"
                  name="isReservedCategory"
                  ref={register({ required: true })}
                />
                &nbsp;{profile.YES}
              </label>
               {_.get("isReservedCategory.type", errors) === "required" && (
                  <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                   </p>
                 )}
              {personalInfoDigilockerStatuses &&
                personalInfoDigilockerStatuses.category_certificate == true ? (
                <span className="digilockerText">
                  &nbsp;&nbsp;
                  <img src="/icons/tickIcon.png" width="20" height="20" />{" "}
                  Digilocker verified
                </span>
              ) : (
                ""
              )}
            </div>

            {personalDetails.isReservedCategory === "Yes" && (
              <>
                <div className="col-md-4">
                  <label className="LeftText f11 font-weight">
                    {commonENLabels.PERSONAL_INFORMATION.NOTE_1_18_1}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.PERSONAL_INFORMATION.NOTE_1_18_1}
                  </label>
                  {personalDetails.isReservedCategory === "Yes" && (
                    <span className="errorText">*</span>
                  )}
                  <div className="input-group">
                    <select
                      className="form-select bg-color"
                      name="categoryLookupId"
                      ref={register({
                        required:
                          personalDetails.isReservedCategory === "Yes"
                            ? true
                            : false,
                      })}
                      value={personalDetails.categoryLookupId}
                      onInput={(e) => {
                        handlePersonalDetailsDropdown(e);
                      }}
                    >
                      <option key={0} value="">
                        {advertisementDetailsLabel.SELECT}
                      </option>
                      {allLookUpList &&
                        allLookUpList.lookupOptionDtoList &&
                        allLookUpList.lookupOptionDtoList
                          .filter((ele) => ele.type === "caste_category" && ele.label !== "Unreserved")
                          .sort((a, b) => { return Number(a.sortOrder) - Number(b.sortOrder) })
                          .map((ele, ind) => {
                            return (
                              <option key={ind} value={ele.id}>
                                {ele.label}
                              </option>
                            );
                          })}
                    </select>
                  </div>
                  {_.get("categoryLookupId.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="LeftText f11 font-weight">
                    {commonENLabels.PERSONAL_INFORMATION.NOTE_1_18_2}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.PERSONAL_INFORMATION.NOTE_1_18_2}
                  </label>
                  {personalDetails.isReservedCategory === "Yes" && (
                    <span className="errorText">*</span>
                  )}
                  <div className="input-group">
                    <select
                      className="form-select bg-color"
                      name="verifyCategoryLookupId"
                      ref={register({
                        required:
                          personalDetails.isReservedCategory === "Yes"
                            ? true
                            : false,
                      })}
                      value={personalDetails.verifyCategoryLookupId}
                      onInput={(e) => {
                        handlePersonalDetailsDropdown(e);
                        checkValidity(e);
                      }}
                    >
                      <option key={0} value="">
                        {advertisementDetailsLabel.SELECT}
                      </option>
                      {allLookUpList &&
                        allLookUpList.lookupOptionDtoList &&
                        allLookUpList.lookupOptionDtoList
                          .filter((ele) => ele.type === "caste_category" && ele.label !== "Unreserved")
                          .sort((a, b) => { return Number(a.sortOrder) - Number(b.sortOrder) })
                          .map((ele, ind) => {
                            return (
                              <option key={ind} value={ele.id}>
                                {ele.label}
                              </option>
                            );
                          })}
                    </select>
                  </div>
                  {_.get("verifyCategoryLookupId.type", errors) ===
                    "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                  {verifyCategoryCodeFlag &&
                    _.get("verifyCategoryLookupId.type", errors) != "required" ? (
                    <p className="errorText">
                      {
                        commonENLabels.PERSONAL_INFORMATION
                          .CATEGORY_CODE_AND_VERIFY_CATEGORY_CODE
                      }
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-4">
                  <label className="LeftText f11 font-weight">
                    {numberformat["1.17"]}&nbsp;
                    {commonENLabels.PERSONAL_INFORMATION.NOTE_1_19}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.PERSONAL_INFORMATION.NOTE_1_19}
                  </label>
                  {personalDetails.isReservedCategory === "Yes" && (
                    <span className="errorText">*</span>
                  )}
                  &nbsp;
                  <div className="input-group">
                    {/* <select
                      className="form-select bg-color"
                      name="castenameLookupId"
                      ref={register({
                        required:
                          personalDetails.isReservedCategory === "Yes"
                            ? true
                            : false,
                      })}
                      value={personalDetails.castenameLookupId}
                      onInput={(e) => {
                        handlePersonalDetailsDropdown(e);
                      }}
                    >
                      <option key={0} value="">
                        {advertisementDetailsLabel.SELECT}
                      </option>
                      {casteNameDropdownValue && casteNameDropdownValue.length > 0 &&
                        casteNameDropdownValue
                          .sort((a, b) => { return Number(a.sortOrder) - Number(b.sortOrder) })
                          .map((ele, ind) => {
                            return (
                              <option key={ind} value={ele.id}>
                                {ele.label}
                              </option>
                            );
                          })}
                    </select> */}
                    <Select
                      className="w-100 bg-color"
                      name="castenameLookupId"
                      value={casteOptions.find(option => option.value === personalDetails.castenameLookupId) || null}
                      getOptionValue={(option) => option.value}
                      getOptionLabel={(option) => option.label}
                      onChange={(selectedOption) => {
                        handlePersonalDetailsDropdown({
                          target: { name: "castenameLookupId", value: selectedOption?.value || "" },
                        });
                      }}
                      isSearchable={true} // Enables search functionality
                      options={casteOptions.sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder))}
                    />
                  </div>
                  {_.get("castenameLookupId.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                </div>
                <div className="col-md-12">
                  <label className="LeftText f11 font-weight">
                    {numberformat["1.18"]}&nbsp;
                    {commonENLabels.PERSONAL_INFORMATION.NOTE_1_20}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.PERSONAL_INFORMATION.NOTE_1_20}
                  </label>
                  {personalDetails.isReservedCategory === "Yes" && (
                    <span className="errorText">*</span>
                  )}
                  &nbsp;
                </div>
                <div className="form-group col-md-4">
                  {((personalDetails.verifyCategoryLookupId == commonENLabels.DATABASE_VALUES.BC_CATEGORY_LOOKUP_ID) || (personalDetails.verifyCategoryLookupId == commonENLabels.DATABASE_VALUES.EBC_CATEGORY_LOOKUP_ID)) ?
                    <>
                      <label className="LeftText f11 font-weight">
                        {commonENLabels.PERSONAL_INFORMATION.NCLC_CERTIFICATE_NO}
                      </label>
                      <label className="f11 margin-top-10">
                        {commonHILabels.PERSONAL_INFORMATION.NCLC_CERTIFICATE_NO}
                      </label>
                    </>
                    :
                    (personalDetails.verifyCategoryLookupId == commonENLabels.DATABASE_VALUES.EWS_CATEGORY_LOOKUP_ID) ?
                      <>
                        <label className="LeftText f11 font-weight">
                          {commonENLabels.PERSONAL_INFORMATION.EWS_CERTIFICATE_NO}
                        </label>
                        <label className="f11 margin-top-10">
                          {commonHILabels.PERSONAL_INFORMATION.EWS_CERTIFICATE_NO}
                        </label>
                      </>
                      :
                      <>
                        <label className="LeftText f11 font-weight">
                          {commonENLabels.PERSONAL_INFORMATION.CASTE_CERTIFICATE_NO}
                        </label>
                        <label className="f11 margin-top-10">
                          {commonHILabels.PERSONAL_INFORMATION.CASTE_CERTIFICATE_NO}
                        </label>
                      </>
                  }
                  {personalDetails.isReservedCategory === "Yes" && (
                    <span className="errorText">*</span>
                  )}
                  <div className="input-group bg-color">
                    <input
                      className="form-control text-uppercase"
                      id="registrationFormControlInput1"
                      type="text"
                      ref={register({
                        required:
                          personalDetails.isReservedCategory === "Yes"
                            ? true
                            : false,
                        pattern: certificateNumbeForNclandDomicileRegex,
                      })}
                      name="casteCertificateNo"
                      // placeholder={
                      //   commonENLabels.PERSONAL_INFORMATION.CASTE_CERTIFICATE_NO
                      // }
                      placeholder={((personalDetails.verifyCategoryLookupId == commonENLabels.DATABASE_VALUES.BC_CATEGORY_LOOKUP_ID) || (personalDetails.verifyCategoryLookupId == commonENLabels.DATABASE_VALUES.EBC_CATEGORY_LOOKUP_ID)) ? commonENLabels.PERSONAL_INFORMATION.NCLC_CERTIFICATE_NO : (personalDetails.verifyCategoryLookupId == commonENLabels.DATABASE_VALUES.EWS_CATEGORY_LOOKUP_ID) ? commonENLabels.PERSONAL_INFORMATION.EWS_CERTIFICATE_NO : commonENLabels.PERSONAL_INFORMATION.CASTE_CERTIFICATE_NO}
                      defaultValue={
                        personal_info_form &&
                        personal_info_form.casteCertificateNo
                      }
                      autoComplete="off"
                    />
                  </div>
                  {_.get("casteCertificateNo.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("casteCertificateNo.type", errors) === "pattern" && (
                    <p className="errorText">
                      {
                        commonENLabels.VALIDATE_MESSAGE
                          .ENTER_VALID_CERTIFICATE_NUMBER
                      }
                    </p>
                  )}
                </div>
                <div className="form-group col-md-4">
                  <label className="LeftText f11 font-weight">
                    {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_2}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_2}
                  </label>
                  {personalDetails.isReservedCategory === "Yes" && (
                    <span className="errorText">*</span>
                  )}
                  <div>
                    <Controller
                      name="ccIssuingDate"
                      control={control}
                      key={
                        personal_info_form && personal_info_form.id
                          ? "ccIssuingDate1"
                          : "ccIssuingDate2"
                      }
                      defaultValue={
                        personal_info_form && personal_info_form.id
                          ? datePickerData.ccIssuingDate
                          : ""
                      }
                      rules={{
                        required:
                          personalDetails.isReservedCategory === "Yes"
                            ? true
                            : false,
                      }}
                      render={({ onChange, value }) => (
                        <div className="date-picker-container">
                          <DatePicker
                            showIcon
                            selected={getFormattedDate(value)}
                            onChange={(e) => {
                              onChange(toUTCDate(e));
                            }}
                            onKeyDown={preventDateManualTyping}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText={commonLabels.DATE_FORMAT}
                            className="form-control bg-color ps-2"
                            maxDate={new Date()}
                            dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                            icon={
                              <img
                                src="/icons/calender.png"
                                className="date-picker-icon"
                              ></img>
                            }
                          />
                        </div>
                      )}
                    />
                    {_.get("ccIssuingDate.type", errors) == "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                  </div>
                </div>
              </>
            )}
            { (personalDetails.isReservedCategory==="Yes") && ((personalDetails.isReservedCategory === "No" && (personalDetails.gender === commonENLabels.DATABASE_VALUES.FEMALE_GENDER_LOOKUP_ID)) || (personalDetails.isReservedCategory === "Yes")) &&
              <div className="col-md-12">
                <label className="LeftText f11 font-weight">
                  {numberformat["1.19"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_21}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_21}
                </label>
                <span className="errorText">*</span>
                &nbsp;
                {<label className="form-check-label position-relative float-end mt-2">
                  <input
                    type="radio"
                    className="RadioText"
                    checked={
                      personalDetails.isCcIssuedByBihar === "No" 
                    }
                    onChange={(e) => {
                      handlePersonalDetailsDropdown(e);
                    }}
                    value="No"
                    name="isCcIssuedByBihar"
                    ref={register({ required: true })}
                  />
                  &nbsp;{commonENLabels.PERSONAL_INFORMATION.CASTE_CERTIFICATE_ISSUED_BY_SDM_DM}
                </label>}

                <label className="form-check-label position-relative float-end mt-2">
                  <input
                    type="radio"
                    checked={
                      personalDetails.isCcIssuedByBihar === "Yes" 
                    }
                    onChange={(e) => {
                      handlePersonalDetailsDropdown(e);
                    }}
                    className="RadioText"
                    value="Yes"
                    name="isCcIssuedByBihar"
                    ref={register({ required: true })}
                  />
                  &nbsp;{commonENLabels.PERSONAL_INFORMATION.CASTE_CERTIFICATE_ISSUED_BY_CO_RO}
                </label>
                       {_.get("isCcIssuedByBihar.type", errors) === "required" && (
                  <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                   </p>
                 )}

              </div>
            }
            <h6 className="text-danger mt-2">
              {commonENLabels.PERSONAL_INFORMATION.CAST_NOTE}
            </h6>
            <h6 className="font-weight">
              {commonHILabels.PERSONAL_INFORMATION.CAST_NOTE}
            </h6>
            <h6 className="mt-1 text-danger">
              {commonHILabels.PERSONAL_INFORMATION.CAST_NOTE_2}
            </h6>
            {(personalDetails && personalDetails.verifyCategoryLookupId && personalDetails.verifyCategoryLookupId == commonENLabels.DATABASE_VALUES.EWS_CATEGORY_LOOKUP_ID) &&
              <h6 className="font-weight mt-1">
                {commonENLabels.PERSONAL_INFORMATION.CAST_NOTE_2}
              </h6>
            }
            <hr></hr>

            {personalDetails.isDomicile === "Yes" &&
              <div className="col-md-12">
                <label className="LeftText f11 font-weight">
                  {numberformat["1.20"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_22}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_22}
                </label>
                <span className="errorText">*</span>
                &nbsp;
                <label className="form-check-label position-relative float-end mt-2">
                  <input
                    type="radio"
                    className="RadioText"
                    checked={personalDetails.isFfGrandchild === "No" ? true : false}
                    onChange={(e) => {
                      handlePersonalDetailsDropdown(e);
                    }}
                    value="No"
                    name="isFfGrandchild"
                    ref={register({ required: true })}
                  />
                  &nbsp;{profile.NO}
                </label>
                <label className="form-check-label position-relative float-end mt-2">
                  <input
                    type="radio"
                    checked={
                      personalDetails.isFfGrandchild === "Yes" ? true : false
                    }
                    onChange={(e) => {
                      handlePersonalDetailsDropdown(e);
                    }}
                    className="RadioText"
                    value="Yes"
                    name="isFfGrandchild"
                    ref={register({ required: true })}
                  />
                  &nbsp;{profile.YES}
                </label>
                    {_.get("isFfGrandchild.type", errors) === "required" && (
                  <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                   </p>
                 )}
              </div>}
            {personalDetails.isFfGrandchild === "Yes" && (
              <>
                <div className="col-md-12">
                  <label className="LeftText f11 font-weight">
                    {numberformat["1.20.1"]}&nbsp;
                    {commonENLabels.PERSONAL_INFORMATION.NOTE_1_23}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.PERSONAL_INFORMATION.NOTE_1_23}
                  </label>

                  {personalDetails.isFfGrandchild === "Yes" && (
                    <span className="errorText">*</span>
                  )}
                  &nbsp;
                </div>
                <h6 className="mt-1 text-danger">
                  Note: (Identity certificates related to the descendants (grandchildren) of freedom fighters will not be accepted.)
                </h6>
                <h6 className="mt-1 text-danger">
                  {commonHILabels.PERSONAL_INFORMATION.FREEDOM_FIGHTER_NOTE}
                </h6>
                <div className="form-group col-md-4">
                  <label className="LeftText f11 font-weight">
                    {commonENLabels.PERSONAL_INFORMATION.FF_CERTIFICATE_NO}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.PERSONAL_INFORMATION.FF_CERTIFICATE_NO}
                  </label>
                  {personalDetails.isFfGrandchild === "Yes" && (
                    <span className="errorText">*</span>
                  )}
                  <div className="input-group bg-color">
                    <input
                      className="form-control text-uppercase"
                      id="registrationFormControlInput1"
                      type="text"
                      ref={register({
                        required:
                          personalDetails.isFfGrandchild === "Yes" ? true : false,
                        pattern: certificateNumbeForNclandDomicileRegex,
                      })}
                      name="ffcNumber"
                      placeholder={
                        commonENLabels.PERSONAL_INFORMATION.FF_CERTIFICATE_NO
                      }
                      defaultValue={
                        personal_info_form && personal_info_form.ffcNumber
                      }
                      autoComplete="off"
                    />
                  </div>
                  {_.get("ffcNumber.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("ffcNumber.type", errors) === "pattern" && (
                    <p className="errorText">
                      {
                        commonENLabels.VALIDATE_MESSAGE
                          .ENTER_VALID_CERTIFICATE_NUMBER
                      }
                    </p>
                  )}
                </div>
                <div className="form-group col-md-4">
                  <label className="LeftText f11 font-weight">
                    {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_2}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_2}
                  </label>
                  {personalDetails.isFfGrandchild === "Yes" && (
                    <span className="errorText">*</span>
                  )}
                  <div>
                    <Controller
                      name="ffcIssuingDate"
                      control={control}
                      key={
                        personal_info_form && personal_info_form.id
                          ? "ffcIssuingDate1"
                          : "ffcIssuingDate2"
                      }
                      defaultValue={
                        personal_info_form && personal_info_form.id
                          ? datePickerData.ffcIssuingDate
                          : ""
                      }
                      rules={{
                        required:
                          personalDetails.isFfGrandchild === "Yes" ? true : false,
                      }}
                      render={({ onChange, value }) => (
                        <div className="date-picker-container">
                          <DatePicker
                            showIcon
                            selected={getFormattedDate(value)}
                            onChange={(e) => {
                              onChange(toUTCDate(e));
                            }}
                            onKeyDown={preventDateManualTyping}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText={commonLabels.DATE_FORMAT}
                            className="form-control bg-color ps-2"
                            maxDate={new Date()}
                            dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                            icon={
                              <img
                                src="/icons/calender.png"
                                className="date-picker-icon"
                              ></img>
                            }
                          />
                        </div>
                      )}
                    />
                    {_.get("ffcIssuingDate.type", errors) == "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                  </div>
                </div>
              </>
            )}
          </div></>}
        <hr></hr>

        {/* Physical Measurement */}
        <h5 className="bottom-dotted-line align-left p-1">
          {profile.PHYSICAL_MESUREMENT} :{" "}
          {commonHILabels.PERSONAL_INFORMATION.PHYSICAL_MESUREMENT}
        </h5>
        <div className="row">
          <div className="form-group col-md-3">
            <label className="LeftText f11">{numberformat["1.21.1"]}&nbsp;{profile.HEIGHT}{commonHILabels.PERSONAL_INFORMATION.HEIGHT}</label>
            <div className="input-group bg-color">
              <input
                type="text"
                className="form-control"
                maxLength={6}
                defaultValue={personal_info_form && personal_info_form.height}
                name="HeightInCMS" ref={register({ required: false, pattern: weightRegex })}
              />
            </div>
            {_.get("HeightInCMS.type", errors) === "required" && (
              <p className="errorText">{profileotherinformation.MANDATORY_FIELD_MESSAGE}</p>
            )}
            {_.get("HeightInCMS.type", errors) === "pattern" && (
              <p className="errorText">{profile.ENTER_NUMERIC_DATA}</p>
            )}
            <span className="Note">{profile.HEIGHT_EX}</span>
          </div>
          <div className="form-group col-md-3">
            <label className="LeftText f11">{numberformat["1.21.2"]}&nbsp;{profile.WEIGHT}{commonHILabels.PERSONAL_INFORMATION.WEIGHT}</label>
            <div className="input-group bg-color">
              <input
                type="text"
                className="form-control"
                maxLength={6}
                defaultValue={personal_info_form && personal_info_form.weight}
                name="Weight" ref={register({ required: false, pattern: weightRegex })}
              />
            </div>
            {_.get("Weight.type", errors) === "required" && (
              <p className="errorText">{profileotherinformation.MANDATORY_FIELD_MESSAGE}</p>
            )}
            {_.get("Weight.type", errors) === "pattern" && (
              <p className="errorText">{profile.ENTER_NUMERIC_DATA}</p>
            )}
            <span className="Note">{profile.WEIGHT_EX}</span>
          </div>
          {(gender == commonENLabels.DATABASE_VALUES.MALE_GENDER_LOOKUP_ID || (Number(gender) === commonENLabels.DATABASE_VALUES.THIRD_GENDER_LOOKUP_ID && flgTransgenderFemale === "No")) ?
            <div className="form-group col-md-3">
              <label className="LeftText f11">{numberformat["1.21.3"]}&nbsp;{profile.CHEST_DEFLATED}{commonHILabels.PERSONAL_INFORMATION.CHEST_DEFLATED}</label>
              <div className="input-group bg-color">
                <input
                  type="text"
                  className="form-control"
                  maxLength={6}
                  max={watch("chestInflated")}
                  defaultValue={personal_info_form && personal_info_form.chestDeflated}
                  name="chestDeflated" ref={register({ required: false, pattern: weightRegex })}
                />
              </div>
              {_.get("chestDeflated.type", errors) === "required" && (

                <p className="errorText">{profileotherinformation.MANDATORY_FIELD_MESSAGE}</p>
              )}
              {_.get("chestDeflated.type", errors) === "pattern" && (
                <p className="errorText">{profile.ENTER_NUMERIC_DATA}</p>
              )}
              {/* {(Number(watch("chestInflated")) <= Number(watch("chestDeflated"))) ? <p className="errorText">{profileotherinformation.CHES_DEFLATED_GREATER_THAN_CHEST_INFLATED}</p> : ""  } */}
              <span className="Note">{profile.CHEST_DEFLATED_EX}</span>
            </div> : ''}
          {(gender == commonENLabels.DATABASE_VALUES.MALE_GENDER_LOOKUP_ID || (Number(gender) === commonENLabels.DATABASE_VALUES.THIRD_GENDER_LOOKUP_ID && flgTransgenderFemale === "No")) ?
            <div className="form-group col-md-3">
              <label className="LeftText f11">{numberformat["1.21.4"]}&nbsp;{profile.CHEST_INFLATED}{commonHILabels.PERSONAL_INFORMATION.CHEST_INFLATED}</label>
              <div className="input-group bg-color">
                <input
                  type="text"
                  className="form-control"
                  maxLength={6}
                  min={watch("chestDeflated")}
                  defaultValue={personal_info_form && personal_info_form.chestInflated}
                  name="chestInflated" ref={register({
                    required: false, pattern: weightRegex,
                  })}
                />
              </div>
              {_.get("chestInflated.type", errors) === "required" && (
                <p className="errorText">{profileotherinformation.MANDATORY_FIELD_MESSAGE}</p>
              )}
              {_.get("chestInflated.type", errors) === "pattern" && (
                <p className="errorText">{profile.ENTER_NUMERIC_DATA}</p>
              )}
              {/* {(Number(watch("chestDeflated")) >= Number(watch("chestInflated"))) ? <p className="errorText">{profileotherinformation.CHES_INFLATED_GREATER_THAN_CHEST_DEFLATED}</p> : ""  } */}
              <span className="Note">{profile.CHEST_INFLATED_EX}</span>
            </div> : ''}
        </div>
        <hr></hr>

        <h5 className="bottom-dotted-line align-left p-1">
          {profile.Divyang_Details} :{" "}
          {commonHILabels.PERSONAL_INFORMATION.DISABILITY_DETAILS}
        </h5>
        {personalDetails.nationalityLookupId !== "No" && <div className="row">
          <div className="col-md-12">
            <label className="LeftText f11 font-weight">
              {numberformat["1.22"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.NOTE_1_24}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.NOTE_1_24}
            </label>
            <span className="errorText">*</span>
            &nbsp;
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                className="RadioText"
                checked={personalDetails.isDivyang === "No" ? true : false}
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                value="No"
                name="isDivyang"
                ref={register({ required: true })}
              />
              &nbsp;{profile.NO}
            </label>
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                checked={personalDetails.isDivyang === "Yes" ? true : false}
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                className="RadioText"
                value="Yes"
                name="isDivyang"
                ref={register({ required: true })}
              />
              &nbsp;{profile.YES}
            </label>

             {_.get("isDivyang.type", errors) === "required" && (
                  <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                   </p>
                 )}
            {personalInfoDigilockerStatuses &&
              personalInfoDigilockerStatuses.disability_certificate == true ? (
              <span className="digilockerText">
                &nbsp;&nbsp;
                <img src="/icons/tickIcon.png" width="20" height="20" />{" "}
                Digilocker verified
              </span>
            ) : (
              ""
            )}
          </div>
          <div className="col-md-12">
            <label className="LeftText f11 font-weight">
              {numberformat["1.22.1"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.DO_YOU_REQUIRE_SCRIBE_DUE_TO_PERSON_WITH_DISABILITY}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.DO_YOU_REQUIRE_SCRIBE_DUE_TO_PERSON_WITH_DISABILITY_hin}
            </label>
            <span className="errorText">*</span>
            &nbsp;

            {/* No Option */}
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                className="RadioText"
                checked={personalDetails.isDisabilityScribeReq === "No"} // Corrected logic
                onChange={handlePersonalDetailsDropdown}
                value="No"
                name="isDisabilityScribeReq"
                ref={register({ required: true })}
                disabled={personalDetails.isDivyang !== "Yes"} // Disabled when isDivyang is No
              />
              &nbsp;{profile.NO}
            </label>

            {/* Yes Option */}
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                className="RadioText"
                checked={personalDetails.isDisabilityScribeReq === "Yes"} // Corrected logic
                onChange={handlePersonalDetailsDropdown}
                value="Yes"
                name="isDisabilityScribeReq"
                ref={register({ required: true })}
                disabled={personalDetails.isDivyang !== "Yes"} // Disabled when isDivyang is No
              />
              &nbsp;{profile.YES}
            </label>
          </div>

          {personalDetails.isDivyang === "Yes" && (
            <>
              <div className="col-md-6">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_24_1}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_24_1}
                </label>
                {personalDetails.isDivyang === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div className="input-group">
                  <select
                    className="form-select bg-color"
                    name="typeOfDisabilityLookupId"
                    ref={register({
                      required:
                        personalDetails.isDivyang === "Yes" ? true : false,
                    })}
                    value={personalDetails.typeOfDisabilityLookupId}
                    onInput={(e) => {
                      handlePersonalDetailsDropdown(e);
                    }}
                  >
                    <option key={0} value="">
                      {advertisementDetailsLabel.SELECT}
                    </option>
                    {allLookUpList &&
                      allLookUpList.lookupOptionDtoList &&
                      allLookUpList.lookupOptionDtoList
                        .filter((ele) => ele.type === "disability_category")
                        .sort((a, b) => { return Number(a.sortOrder) - Number(b.sortOrder) })
                        .map((ele, ind) => {
                          return (
                            <option key={ind} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                  </select>
                </div>
                {_.get("typeOfDisabilityLookupId.type", errors) ===
                  "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
              </div>
              <div className="col-md-6">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_24_2}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_24_2}
                </label>
                {personalDetails.isDivyang === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div className="input-group">
                  <select
                    className="form-select bg-color"
                    name="verifiedNatureOfDivyang"
                    ref={register({
                      required:
                        personalDetails.isDivyang === "Yes" ? true : false,
                    })}
                    value={personalDetails.verifiedNatureOfDivyang}
                    onInput={(e) => {
                      handlePersonalDetailsDropdown(e);
                      checkValidity(e);
                    }}
                  >
                    <option key={0} value="">
                      {advertisementDetailsLabel.SELECT}
                    </option>
                    {allLookUpList &&
                      allLookUpList.lookupOptionDtoList &&
                      allLookUpList.lookupOptionDtoList
                        .filter((ele) => ele.type === "disability_category")
                        .sort((a, b) => { return Number(a.sortOrder) - Number(b.sortOrder) })
                        .map((ele, ind) => {
                          return (
                            <option key={ind} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                  </select>
                </div>
                {_.get("verifiedNatureOfDivyang.type", errors) ===
                  "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                {verifyDisabilityFlag &&
                  _.get("verifiedNatureOfDivyang.type", errors) != "required" ? (
                  <p className="errorText">
                    {
                      commonENLabels.PERSONAL_INFORMATION
                        .DISABILITY_AND_VERIFY_DISABILITY
                    }
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-12">
                <label className="LeftText f11 font-weight">
                  {numberformat["1.23"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_25}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_25}
                </label>
                {personalDetails.isDivyang === "Yes" && (
                  <span className="errorText">*</span>
                )}
                &nbsp;
              </div>
              <div className="form-group col-md-4">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.DISABILITY_CERTIFICATE_NO}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.DISABILITY_CERTIFICATE_NO}
                </label>
                {personalDetails.isDivyang === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div className="input-group bg-color">
                  <input
                    className="form-control text-uppercase"
                    id="registrationFormControlInput1"
                    type="text"
                    ref={register({
                      required:
                        personalDetails.isDivyang === "Yes" ? true : false,
                      pattern: certificateNumbeForNclandDomicileRegex,
                    })}
                    name="sadmCertificateNumber"
                    placeholder={
                      commonENLabels.PERSONAL_INFORMATION.DISABILITY_CERTIFICATE_NO
                    }
                    defaultValue={
                      personal_info_form &&
                      personal_info_form.sadmCertificateNumber
                    }
                    autoComplete="off"
                  />
                </div>
                {_.get("sadmCertificateNumber.type", errors) === "required" && (
                  <p className="errorText">
                    {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                  </p>
                )}
                {_.get("sadmCertificateNumber.type", errors) === "pattern" && (
                  <p className="errorText">
                    {
                      commonENLabels.VALIDATE_MESSAGE
                        .ENTER_VALID_CERTIFICATE_NUMBER
                    }
                  </p>
                )}
              </div>
              <div className="form-group col-md-4">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_2}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_2}
                </label>
                {personalDetails.isDivyang === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div>
                  <Controller
                    name="sadmCertificateDate"
                    control={control}
                    key={
                      personal_info_form && personal_info_form.id
                        ? "sadmCertificateDate1"
                        : "sadmCertificateDate2"
                    }
                    defaultValue={
                      personal_info_form && personal_info_form.id
                        ? datePickerData.sadmCertificateDate
                        : ""
                    }
                    rules={{
                      required:
                        personalDetails.isDivyang === "Yes" ? true : false,
                    }}
                    render={({ onChange, value }) => (
                      <div className="date-picker-container">
                        <DatePicker
                          showIcon
                          selected={getFormattedDate(value)}
                          onChange={(e) => {
                            onChange(toUTCDate(e));
                          }}
                          onKeyDown={preventDateManualTyping}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText={commonLabels.DATE_FORMAT}
                          className="form-control bg-color ps-2"
                          maxDate={new Date()}
                          minDate={getFormattedDate(authenticatedUserData?.dob)}
                          dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                          icon={
                            <img
                              src="/icons/calender.png"
                              className="date-picker-icon"
                            ></img>
                          }
                        />
                      </div>
                    )}
                  />
                  {_.get("sadmCertificateDate.type", errors) == "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                </div>
              </div>
              <div className="form-group col-md-4">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.DISABILITY_PERCENTAGE}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.DISABILITY_PERCENTAGE}
                </label>
                {personalDetails.isDivyang === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div className="input-group">
                  {/* <input
                    className="form-control text-uppercase"
                    id="registrationFormControlInput1"
                    type="text"
                    ref={register({
                      required:
                        personalDetails.isDivyang === "Yes" ? true : false,
                      pattern: divyangPercentageRegex,
                    })}
                    name="divyangPercentage"
                    placeholder={
                      commonENLabels.PERSONAL_INFORMATION.DISABILITY_PERCENTAGE
                    }
                    defaultValue={
                      personal_info_form &&
                      personal_info_form.divyangPercentage
                    }
                    autoComplete="off"
                  /> */}
                  <select
                    className="form-select bg-color"
                    id="registrationFormControlInput1"
                    type="text"
                    ref={register({
                      required:
                        personalDetails.isDivyang === "Yes" ? true : false,
                      pattern: alphanumeric,
                    })}
                    name="divyangPercentage"
                    value={
                      personalDetails &&
                      personalDetails.divyangPercentage
                    }
                    onInput={(e) => {
                      handlePersonalDetailsDropdown(e);
                    }}
                  >
                    <option key={0} value="">
                      {advertisementDetailsLabel.SELECT}
                    </option>
                    {allLookUpList &&
                      allLookUpList.lookupOptionDtoList &&
                      allLookUpList.lookupOptionDtoList
                        .filter((ele) => ele.type === "divyang_percentage")
                        .sort((a, b) => { return Number(a.sortOrder) - Number(b.sortOrder) })
                        .map((ele, ind) => {
                          return (
                            <option key={ind} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                  </select>
                </div>
                {_.get("divyangPercentage.type", errors) === "required" && (
                  <p className="errorText">
                    {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                  </p>
                )}
                {_.get("divyangPercentage.type", errors) === "pattern" && (
                  <p className="errorText">
                    {
                      commonENLabels.VALIDATE_MESSAGE
                        .ENTER_VALID_DIVYANG_PERCENTAGE
                    }
                  </p>
                )}
              </div>
              <div className="col-md-6 mt-3">
                <label className="LeftText f11 font-weight">
                  {numberformat["1.24"]}&nbsp;
                  <span> {commonENLabels.PERSONAL_INFORMATION.NOTE_1_26} </span><br />
                  <span className="ms-4 mb-1"> {commonHILabels.PERSONAL_INFORMATION.NOTE_1_26} </span>
                  {personalDetails.isDivyang === "Yes" && (
                    <span className="errorText">*</span>
                  )}
                </label>
                &nbsp;
              </div>
              <div className="col-md-6 mt-3">
                <div className="input-group">
                  <select
                    className="form-select bg-color"
                    name="dbcIssuingInstituteLookupId"
                    ref={register({
                      required:
                        personalDetails.isDivyang === "Yes" ? true : false,
                    })}
                    value={personalDetails.dbcIssuingInstituteLookupId}
                    onInput={(e) => {
                      handlePersonalDetailsDropdown(e);
                    }}
                  >
                    <option key={0} value="">
                      {advertisementDetailsLabel.SELECT}
                    </option>
                    {allLookUpList &&
                      allLookUpList.lookupOptionDtoList &&
                      allLookUpList.lookupOptionDtoList
                        .filter(
                          (ele) =>
                            ele.type ===
                            "disability_certificate_issuing_institute"
                        )
                        .sort((a, b) => { return Number(a.sortOrder) - Number(b.sortOrder) })
                        .map((ele, ind) => {
                          return (
                            <option key={ind} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                  </select>
                </div>
                {_.get("dbcIssuingInstituteLookupId.type", errors) ===
                  "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
              </div>
              <h6 className="text-danger mt-1 font-weight">
                {commonHILabels.PERSONAL_INFORMATION.NOTE_1_26_1}
              </h6>
              <h6 className="text-danger mt-1 font-weight">
                {commonHILabels.PERSONAL_INFORMATION.NOTE_1_26_2}
              </h6>
              <h6 className="text-danger mt-1 font-weight">
                {commonENLabels.PERSONAL_INFORMATION.NOTE_1_26_3}
              </h6>
            </>
          )}

        </div>}
        <hr></hr>
        <h5 className="bottom-dotted-line align-left p-1">
          {profile.Sports_Details} :{" "}
          {commonHILabels.PERSONAL_INFORMATION.SPORTS_DETAILS}
        </h5>
        {personalDetails.nationalityLookupId !== "No" && <div className="form-group row">
          <div className="col-md-12">
            <label className="LeftText ">
              {numberformat["1.25"]}&nbsp;{" "}
              {profileotherinformation["ARE_YOU _MERITORIOUS_SPORTS_PERSON?"]}
              {commonHILabels.PERSONAL_INFORMATION.SPORT_PERSON_NOTE}
              <span className="redColor">*</span>
            </label>
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                className="RadioText"
                checked={
                  SportsBooleanState.isMetritoriousSportsman === "No"
                    ? true
                    : false
                }
                onChange={(e) => {
                  handleSportsPersonalInfoBooleanState(e);
                }}
                value="No"
                name="isMetritoriousSportsman"
                ref={register({ required: true })}
              />
              &nbsp;{profile.NO}
            </label>
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                checked={
                  SportsBooleanState.isMetritoriousSportsman === "Yes"
                    ? true
                    : false
                }
                onChange={(e) => {
                  handleSportsPersonalInfoBooleanState(e);
                }}
                className="RadioText"
                value="Yes"
                name="isMetritoriousSportsman"
                ref={register({ required: true })}
              />
              &nbsp;{profile.YES}
            </label>
          </div>
             {_.get("isMetritoriousSportsman.type", errors) === "required" && (
                  <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                   </p>
                 )}
        </div>}
        {/* {SportsBooleanState &&
          SportsBooleanState.isMetritoriousSportsman === "Yes" ? (
          <div>
            <SportsTable />
            <div className="mt-1">
              <SportsDetails />
            </div>
          </div>
          ) : (
          ""
              )} */}
        <hr></hr>

        {/* Ex-serviceman details */}
        <h5 className="bottom-dotted-line align-left p-1">
          {profile.Ex_service_Man} :{" "}
          {commonHILabels.PERSONAL_INFORMATION.EX_SERVICEMAN}
        </h5>
        {personalDetails.nationalityLookupId !== "No" && <div className="row">
          <div className="col-md-12">
            <label className="LeftText f11 font-weight">
              {numberformat["1.26"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.NOTE_1_38}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.NOTE_1_38}
            </label>
            <span className="errorText">*</span>
            &nbsp;
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                className="RadioText"
                checked={personalDetails.isExArmedReg === "No" ? true : false}
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                value="No"
                name="isExArmedReg"
                ref={register({ required: true })}
              />
              &nbsp;{profile.NO}
            </label>
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                checked={personalDetails.isExArmedReg === "Yes" ? true : false}
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                className="RadioText"
                value="Yes"
                name="isExArmedReg"
                ref={register({ required: true })}
              />
              &nbsp;{profile.YES}
            </label>
                {_.get("isExArmedReg.type", errors) === "required" && (
                  <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                   </p>
                 )}
          </div>

          {personalDetails.isExArmedReg === "Yes" && (
            <>
              <div className="col-md-12">
                <label className="LeftText f11 font-weight">
                  {numberformat["1.27"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_39}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_39}
                </label>
                {personalDetails.isExArmedReg === "Yes" && (
                  <span className="errorText">*</span>
                )}
                &nbsp;
              </div>
              <div className="form-group col-md-4">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.EX_SERVICEMAN_CERTIFICATE_NO}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.EX_SERVICEMAN_CERTIFICATE_NO}
                </label>
                {personalDetails.isExArmedReg === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div className="input-group bg-color">
                  <input
                    className="form-control text-uppercase"
                    id="registrationFormControlInput1"
                    type="text"
                    ref={register({
                      required:
                        personalDetails.isExArmedReg === "Yes" ? true : false,
                      pattern: certificateNumbeForNclandDomicileRegex,
                    })}
                    name="dischargeCertificateNo"
                    placeholder={
                      commonENLabels.PERSONAL_INFORMATION.EX_SERVICEMAN_CERTIFICATE_NO
                    }
                    defaultValue={
                      personal_info_form &&
                      personal_info_form.dischargeCertificateNo
                    }
                    autoComplete="off"
                  />
                </div>
                {_.get("dischargeCertificateNo.type", errors) ===
                  "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                {_.get("dischargeCertificateNo.type", errors) === "pattern" && (
                  <p className="errorText">
                    {
                      commonENLabels.VALIDATE_MESSAGE
                        .ENTER_VALID_CERTIFICATE_NUMBER
                    }
                  </p>
                )}
              </div>
              <div className="form-group col-md-2">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_FROM_DATE}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_FROM_DATE}
                </label>
                {personalDetails.isExArmedReg === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div>
                  <Controller
                    name="dateDischargeArmedRegular"
                    control={control}
                    key={
                      personal_info_form && personal_info_form.id
                        ? "dateDischargeArmedRegular1"
                        : "dateDischargeArmedRegular2"
                    }
                    defaultValue={
                      personal_info_form && personal_info_form.id
                        ? datePickerData.dateDischargeArmedRegular
                        : ""
                    }
                    rules={{
                      required:
                        personalDetails.isExArmedReg === "Yes" ? true : false,
                    }}
                    render={({ onChange, value }) => (
                      <div className="date-picker-container">
                        <DatePicker
                          showIcon
                          selected={getFormattedDate(value)}
                          onChange={(e) => {
                            onChange(toUTCDate(e));
                          }}
                          onKeyDown={preventDateManualTyping}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText={commonLabels.DATE_FORMAT}
                          className="form-control bg-color ps-2"
                          maxDate={watch("exServiceManToDate") || new Date()}
                          minDate={getFormattedDate(authenticatedUserData?.dob)}
                          dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                          icon={
                            <img
                              src="/icons/calender.png"
                              className="date-picker-icon"
                            ></img>
                          }
                        />
                      </div>
                    )}
                  />
                  {_.get("dateDischargeArmedRegular.type", errors) ==
                    "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                </div>
              </div>
              <div className="form-group col-md-2">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_TO_DATE}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_TO_DATE}
                </label>
                {personalDetails.isExArmedReg === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div>
                  <Controller
                    name="exServiceManToDate"
                    control={control}
                    key={
                      personal_info_form && personal_info_form.id
                        ? "exServiceManToDate1"
                        : "exServiceManToDate2"
                    }
                    defaultValue={
                      personal_info_form && personal_info_form.id
                        ? datePickerData.exServiceManToDate
                        : ""
                    }
                    rules={{
                      required:
                        personalDetails.isExArmedReg === "Yes" ? true : false,
                    }}
                    render={({ onChange, value }) => (
                      <div className="date-picker-container">
                        <DatePicker
                          showIcon
                          selected={getFormattedDate(value)}
                          onChange={(e) => {
                            onChange(toUTCDate(e));
                          }}
                          onKeyDown={preventDateManualTyping}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText={commonLabels.DATE_FORMAT}
                          className="form-control bg-color ps-2"
                          maxDate={new Date()}
                          minDate={watch("dateDischargeArmedRegular") || new Date()}
                          dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                          icon={
                            <img
                              src="/icons/calender.png"
                              className="date-picker-icon"
                            ></img>
                          }
                        />
                      </div>
                    )}
                  />
                  {_.get("exServiceManToDate.type", errors) ==
                    "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                </div>
              </div>
              <div className="col-md-1 mt-1">
                <label className="float-start font-weight">
                  {commonENLabels.COMMON.YEARS}
                </label>
                <div className="input-group bg-color">
                  <input type="text" className="form-control"
                    name="expYears" value={exServicemanDateDifference && exServicemanDateDifference.years ? exServicemanDateDifference.years : 0} disabled></input>
                </div>
              </div>
              <div className="col-md-1 mt-1">
                <label className="float-start font-weight">
                  {commonENLabels.COMMON.MONTHS}
                </label>
                <div className="input-group bg-color">
                  <input type="text" className="form-control" name="expMonths" value={exServicemanDateDifference && exServicemanDateDifference.months ? exServicemanDateDifference.months : 0} disabled></input>
                </div>
              </div>
              <div className="col-md-1 mt-1 font-weight">
                <label className="float-start">
                  {commonENLabels.COMMON.DAYS}
                </label>
                <div className="input-group bg-color">
                  <input type="text" className="form-control" name="expDays" value={exServicemanDateDifference && exServicemanDateDifference.days ? exServicemanDateDifference.days : 0} disabled></input>
                </div>
              </div>
            </>
          )}
        </div>}

        {/* N.C.C Cadet details */}
        <hr></hr>
        <h5 className="bottom-dotted-line align-left p-1">
          {commonENLabels.PERSONAL_INFORMATION.NCC_CADET}{" "}
          {commonHILabels.PERSONAL_INFORMATION.NCC_CADET}
        </h5>
        {personalDetails.nationalityLookupId !== "No" && <div className="row">
          <div className="col-md-12">
            <label className="LeftText f11 font-weight">
              {numberformat["1.28"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.NOTE_1_40}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.NOTE_1_40}
            </label>
            <span className="errorText">*</span>
            &nbsp;
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                className="RadioText"
                checked={personalDetails.isNccCadet === "No" ? true : false}
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                value="No"
                name="isNccCadet"
                ref={register({ required: true })}
              />
              &nbsp;{profile.NO}
            </label>
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                checked={personalDetails.isNccCadet === "Yes" ? true : false}
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                className="RadioText"
                value="Yes"
                name="isNccCadet"
                ref={register({ required: true })}
              />
              &nbsp;{profile.YES}
            </label>
                {_.get("isNccCadet.type", errors) === "required" && (
                  <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                   </p>
                 )}
          </div>

          {personalDetails.isNccCadet === "Yes" && (
            <>
              <div className="col-md-12">
                <label className="LeftText f11 font-weight">
                  {numberformat["1.29"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_41}
                </label>
                <label className="f11 margin-top-10 font-weight">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_41}
                </label>
                {personalDetails.isNccCadet === "Yes" && (
                  <span className="errorText">*</span>
                )}
                &nbsp;
              </div>
              <div className="form-group col-md-4">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.NCC_CERTIFICATE_NO}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NCC_CERTIFICATE_NO}
                </label>
                {personalDetails.isNccCadet === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div className="input-group bg-color">
                  <input
                    className="form-control text-uppercase"
                    id="registrationFormControlInput1"
                    type="text"
                    ref={register({
                      required:
                        personalDetails.isNccCadet === "Yes" ? true : false,
                      pattern: certificateNumbeForNclandDomicileRegex,
                    })}
                    name="nccCertificateNo"
                    placeholder={
                      commonENLabels.PERSONAL_INFORMATION.NCC_CERTIFICATE_NO
                    }
                    defaultValue={
                      personal_info_form && personal_info_form.nccCertificateNo
                    }
                    autoComplete="off"
                  />
                </div>
                {_.get("nccCertificateNo.type", errors) === "required" && (
                  <p className="errorText">
                    {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                  </p>
                )}
                {_.get("nccCertificateNo.type", errors) === "pattern" && (
                  <p className="errorText">
                    {
                      commonENLabels.VALIDATE_MESSAGE
                        .ENTER_VALID_CERTIFICATE_NUMBER
                    }
                  </p>
                )}
              </div>
              <div className="form-group col-md-2">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_FROM_DATE}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_FROM_DATE}
                </label>
                {personalDetails.isNccCadet === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div>
                  <Controller
                    name="ncccIssuingDate"
                    control={control}
                    rules={{
                      required:
                        personalDetails.isNccCadet === "Yes" ? true : false,
                    }}
                    key={
                      personal_info_form && personal_info_form.id
                        ? "ncccIssuingDate1"
                        : "ncccIssuingDate2"
                    }
                    defaultValue={
                      personal_info_form && personal_info_form.id
                        ? datePickerData.ncccIssuingDate
                        : ""
                    }
                    render={({ onChange, value }) => (
                      <div className="date-picker-container">
                        <DatePicker
                          showIcon
                          selected={getFormattedDate(value)}
                          onChange={(e) => {
                            onChange(toUTCDate(e));
                          }}
                          onKeyDown={preventDateManualTyping}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText={commonLabels.DATE_FORMAT}
                          className="form-control bg-color ps-2"
                          maxDate={watch("nccToDate") || new Date()}
                          minDate={getFormattedDate(authenticatedUserData?.dob)}
                          dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                          icon={
                            <img
                              src="/icons/calender.png"
                              className="date-picker-icon"
                            ></img>
                          }
                        />
                      </div>
                    )}
                  />
                  {_.get("ncccIssuingDate.type", errors) == "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                </div>
              </div>
              <div className="form-group col-md-2">
                <label className="LeftText f11 font-weight">
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_17_TO_DATE}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_17_TO_DATE}
                </label>
                {personalDetails.isNccCadet === "Yes" && (
                  <span className="errorText">*</span>
                )}
                <div>
                  <Controller
                    name="nccToDate"
                    control={control}
                    key={
                      personal_info_form && personal_info_form.id
                        ? "nccToDate1"
                        : "nccToDate2"
                    }
                    defaultValue={
                      personal_info_form && personal_info_form.id
                        ? datePickerData.nccToDate
                        : ""
                    }
                    rules={{
                      required:
                        personalDetails.isNccCadet === "Yes" ? true : false,
                    }}
                    render={({ onChange, value }) => (
                      <div className="date-picker-container">
                        <DatePicker
                          showIcon
                          selected={getFormattedDate(value)}
                          onChange={(e) => {
                            onChange(toUTCDate(e));
                          }}
                          onKeyDown={preventDateManualTyping}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText={commonLabels.DATE_FORMAT}
                          className="form-control bg-color ps-2"
                          maxDate={new Date()}
                          minDate={watch("ncccIssuingDate") || new Date()}
                          dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                          icon={
                            <img
                              src="/icons/calender.png"
                              className="date-picker-icon"
                            ></img>
                          }
                        />
                      </div>
                    )}
                  />
                  {_.get("nccToDate.type", errors) ==
                    "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                </div>
              </div>
              <div className="col-md-1 mt-1">
                <label className="float-start font-weight">
                  {commonENLabels.COMMON.YEARS}
                </label>
                <div className="input-group bg-color">
                  <input type="text" className="form-control" name="expYears" value={nccDateDifference && nccDateDifference.years ? nccDateDifference.years : 0} disabled></input>
                </div>
              </div>
              <div className="col-md-1 mt-1">
                <label className="float-start font-weight">
                  {commonENLabels.COMMON.MONTHS}
                </label>
                <div className="input-group bg-color">
                  <input type="text" className="form-control" name="expMonths" value={nccDateDifference && nccDateDifference.months ? nccDateDifference.months : 0} disabled></input>
                </div>
              </div>
              <div className="col-md-1 mt-1">
                <label className="float-start font-weight">
                  {commonENLabels.COMMON.DAYS}
                </label>
                <div className="input-group bg-color">
                  <input type="text" className="form-control" name="expDays" value={nccDateDifference && nccDateDifference.days ? nccDateDifference.days : 0} disabled></input>
                </div>
              </div>
            </>
          )}
        </div>}
        <hr></hr>

        {personalDetails.nationalityLookupId !== "No" && <h5 className="bottom-dotted-line align-left p-1">
          {commonENLabels.PERSONAL_INFORMATION.GOVT_EMP} :{" "}
          {commonHILabels.PERSONAL_INFORMATION.GOVT_EMP}
        </h5>}
        {personalDetails.nationalityLookupId !== "No" && <div className="row">
          <div className="col-md-12">
            <label className="LeftText f11 font-weight">
              {numberformat["1.30"]}&nbsp;
              {commonENLabels.PERSONAL_INFORMATION.NOTE_1_42}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.PERSONAL_INFORMATION.NOTE_1_42}
            </label>
            <span className="errorText">*</span>
            &nbsp;
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                className="RadioText"
                checked={personalDetails.isGobEmployee === "No" ? true : false}
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                value="No"
                name="isGobEmployee"
                ref={register({ required: true })}
              />
              &nbsp;{profile.NO}
            </label>
            <label className="form-check-label position-relative float-end mt-2">
              <input
                type="radio"
                checked={personalDetails.isGobEmployee === "Yes" ? true : false}
                onChange={(e) => {
                  handlePersonalDetailsDropdown(e);
                }}
                className="RadioText"
                value="Yes"
                name="isGobEmployee"
                ref={register({ required: true })}
              />
              &nbsp;{profile.YES}
            </label>
                {_.get("isGobEmployee.type", errors) === "required" && (
                  <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.PLEASE_SELECT_ANY_ONE}
                   </p>
                 )}
          </div>

          {personalDetails.isGobEmployee === "Yes" && (
            <>
              <div className="col-md-8 mt-3">
                <label className="LeftText f11 font-weight">
                  {numberformat["1.31"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_43}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_43}
                </label>
                {personalDetails.isGobEmployee === "Yes" && (
                  <span className="errorText">*</span>
                )}
                &nbsp;
              </div>
              <div className="col-md-4 mt-3">
                <div className="">
                  {/* <select
                    className="form-select bg-color"
                    name="jobDesignation"
                    ref={register({
                      required:
                        personalDetails.isGobEmployee === "Yes" ? true : false,
                    })}
                    value={personalDetails.jobDesignation}
                    onInput={(e) => {
                      handlePersonalDetailsDropdown(e);
                    }}
                  >
                    <option key={0} value="">
                      {advertisementDetailsLabel.SELECT}
                    </option>
                    {allLookUpList &&
                      allLookUpList.lookupOptionDtoList &&
                      allLookUpList.lookupOptionDtoList
                        .filter((ele) => ele.type === "designation")
                        .map((ele, ind) => {
                          return (
                            <option key={ind} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                  </select> */}
                  <>
                    <Select
                      value={selectedOption}
                      onChange={(selected) => {
                        handlePersonalDetailsDropdown({
                          target: {
                            name: 'jobDesignation',
                            value: selected?.value || '',
                          },
                        });
                      }}
                      options={options}
                      isSearchable
                      name="jobDesignation"
                      placeholder={advertisementDetailsLabel.SELECT}
                    />
                    <input
                      type="hidden"
                      name="jobDesignation"
                      value={personalDetails.jobDesignation}
                      ref={register({
                        required: personalDetails.isGobEmployee === 'Yes',
                      })}
                    />
                  </>
                </div>
                {_.get("jobDesignation.type", errors) === "required" && (
                  <p className="errorText">
                    {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                  </p>
                )}
              </div>

              <div className="col-md-8 mt-3">
                <label className="LeftText f11 font-weight">
                  {numberformat["1.32"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_44}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_44}
                </label>
                {personalDetails.isGobEmployee === "Yes" && (
                  <span className="errorText">*</span>
                )}
                &nbsp;
              </div>
              <div className="col-md-4 mt-3">
                <div className="input-group bg-color">
                  <input
                    className="form-control text-uppercase"
                    id="registrationFormControlInput1"
                    type="text"
                    ref={register({
                      required:
                        personalDetails.isGobEmployee === "Yes" ? true : false,
                    })}
                    name="jobOffice"
                    placeholder={
                      commonENLabels.PERSONAL_INFORMATION.NOTE_1_44_PLACEHOLDER
                    }
                    defaultValue={
                      personal_info_form && personal_info_form.jobOffice
                    }
                    autoComplete="off"
                  />
                </div>
                {_.get("jobOffice.type", errors) === "required" && (
                  <p className="errorText">
                    {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                  </p>
                )}
              </div>

              <div className="col-md-8 mt-3">
                <label className="LeftText f11 font-weight">
                  {numberformat["1.33"]}&nbsp;
                  {commonENLabels.PERSONAL_INFORMATION.NOTE_1_45}
                </label>
                <label className="f11 margin-top-10">
                  {commonHILabels.PERSONAL_INFORMATION.NOTE_1_45}
                </label>
                {personalDetails.isGobEmployee === "Yes" && (
                  <span className="errorText">*</span>
                )}
                &nbsp;
              </div>
              <div className="col-md-4 mt-3">
                <div className="input-group bg-color">
                  <input
                    className="form-control text-uppercase"
                    id="registrationFormControlInput1"
                    type="text"
                    ref={register({
                      required:
                        personalDetails.isGobEmployee === "Yes" ? true : false,
                    })}
                    name="jobPlace"
                    placeholder={
                      commonENLabels.PERSONAL_INFORMATION.NOTE_1_45_PLACEHOLDER
                    }
                    defaultValue={
                      personal_info_form && personal_info_form.jobPlace
                    }
                    autoComplete="off"
                  />
                </div>
                {_.get("jobPlace.type", errors) === "required" && (
                  <p className="errorText">
                    {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                  </p>
                )}
              </div>
            </>
          )}
        </div>}
        <hr></hr>



        {/* {personalDetails.nationalityLookupId === "Yes" &&
          <div className="text-center">
            {
              profileFormDetailsData.isLocked !== true ? (
                <button
                  type="submit"
                  disabled={
                    isDisableAllTabSave ||
                    (SportsBooleanState.isMetritoriousSportsman === "Yes" &&
                      (!meritoriousSportsmanDtoList || meritoriousSportsmanDtoList.length === 0)) ||
                    verifyPermenantResidentFlg
                  }
                  className="btn btn-primary custom_button m-1"
                >
                  {profile.SAVE}
                </button>
              ) : (
                <span className="profile_disable_button">
                  {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
                </span>
              )
            }
          </div>
        } */}

        {personalDetails.nationalityLookupId === "Yes" && (
          props.profileStatus !== true ? (
            <div className="text-center">
              <button
                type="submit"
                disabled={
                  isDisableAllTabSave ||
                  // (SportsBooleanState.isMetritoriousSportsman === "Yes" &&
                  //   (!meritoriousSportsmanDtoList || meritoriousSportsmanDtoList.length === 0)) 
                  // ||
                  verifyPermenantResidentFlg
                }
                className="btn btn-primary custom_button m-1"
              >
                {profile.SAVE}
              </button>
            </div>
          ) : (
            <div className="text-center">
              {(() => {
                const personalInfoList = props.enableEditProfileWithLock?.PersonalInfo?.split(",") || [];
                const canUpdate = personalInfoList.includes("U");
                const canCreate = personalInfoList.includes("C");
                const isReadOnly = personalInfoList.includes("R");

                if (props.enableEditProfileWithLock?.editProfileWithLock == "1") {
                  if (canUpdate || canCreate) {
                    return (
                      <button
                        type="submit"
                        disabled={
                          isDisableAllTabSave ||
                          (SportsBooleanState.isMetritoriousSportsman === "Yes" &&
                            (!meritoriousSportsmanDtoList || meritoriousSportsmanDtoList.length === 0)) ||
                          verifyPermenantResidentFlg
                        }
                        className="btn btn-primary custom_button m-1"
                      >
                        {profile.SAVE}
                      </button>
                    );
                  } else if (isReadOnly) {
                    return (
                      <span className="profile_disable_button">
                        {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
                      </span>
                    );
                  }
                }
                return null;
              })()}
            </div>
          )
        )}



      </div>
    </form>
  );
}
export default PersonalInformation;
